import { createFullURL } from './config.js';
/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * POS 系統後端 API
 * POS 系統後端 API 文檔
 * OpenAPI spec version: dev
 */
import useSwr from 'swr';
import useSWRMutation from 'swr/mutation';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortDirection = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountRuleType = {
    PERCENTAGE: 'PERCENTAGE',
    FIXED_AMOUNT: 'FIXED_AMOUNT',
    BOGO: 'BOGO',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountTargetType = {
    ALL: 'ALL',
    CATEGORY: 'CATEGORY',
    PRODUCT: 'PRODUCT',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponChannelRestriction = {
    all: 'all',
    in_store: 'in_store',
    delivery: 'delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsTargetType = {
    ALL: 'ALL',
    CATEGORY: 'CATEGORY',
    PRODUCT: 'PRODUCT',
    PRODUCTS: 'PRODUCTS',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponType = {
    DISCOUNT: 'DISCOUNT',
    REDEEM: 'REDEEM',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponValidityType = {
    RELATIVE_DAYS: 'RELATIVE_DAYS',
    FIXED_RANGE: 'FIXED_RANGE',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponTriggerType = {
    MANUAL: 'MANUAL',
    NEW_MEMBER: 'NEW_MEMBER',
    BIRTHDAY: 'BIRTHDAY',
    OVER_AMOUNT: 'OVER_AMOUNT',
    DORMANT_WAKE: 'DORMANT_WAKE',
    SURVEY_THANK_YOU: 'SURVEY_THANK_YOU',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatusNew = {
    成立: '成立',
    作廢: '作廢',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentStatus = {
    已付款: '已付款',
    待付款: '待付款',
    未付款: '未付款',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShippingStatus = {
    待出貨: '待出貨',
    待處理: '待處理',
    處理中: '處理中',
    已出貨: '已出貨',
    已送達: '已送達',
    已取貨: '已取貨',
    已退回: '已退回',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentStatus = {
    scheduled: 'scheduled',
    checked_in: 'checked_in',
    cancelled: 'cancelled',
    no_show: 'no_show',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckInResponseDataStatus = {
    scheduled: 'scheduled',
    checked_in: 'checked_in',
    cancelled: 'cancelled',
    no_show: 'no_show',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAppointmentRequestStatus = {
    scheduled: 'scheduled',
    checked_in: 'checked_in',
    cancelled: 'cancelled',
    no_show: 'no_show',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemAge = {
    '25歲以下': '25歲以下',
    '26-45歲': '26-45歲',
    '46歲以上': '46歲以上',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemGender = {
    男: '男',
    女: '女',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemLocation = {
    附近: '附近',
    外地: '外地',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemPurchaseFrequency = {
    每週3次以上: '每週3次以上',
    '每週1~3次': '每週1~3次',
    偶爾: '偶爾',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemPurchaseLocationItem = {
    麵包店: '麵包店',
    便利商店: '便利商店',
    量販超市: '量販超市',
    網購: '網購',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemPurchaseTime = {
    '早上(6:00~12:00)': '早上(6:00~12:00)',
    '下午(12:00~17:00)': '下午(12:00~17:00)',
    '晚上(17:00後)': '晚上(17:00後)',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemMealType = {
    早餐: '早餐',
    點心: '點心',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemPurchaseFactorsItem = {
    價格: '價格',
    健康: '健康',
    好吃: '好吃',
    口味嚐鮮: '口味嚐鮮',
    美觀: '美觀',
    衛生: '衛生',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemHealthPrice = {
    會: '會',
    不會: '不會',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemNaturalPreference = {
    在意: '在意',
    不在意: '不在意',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemTastePreferenceItem = {
    原味: '原味',
    鹹: '鹹',
    甜: '甜',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyListResponseSurveysItemBreadTypesItem = {
    吐司: '吐司',
    '台式、日式麵包': '台式、日式麵包',
    歐式麵包: '歐式麵包',
    法國麵包: '法國麵包',
    丹麥可頌: '丹麥可頌',
    貝果系列: '貝果系列',
    無麩質麵包: '無麩質麵包',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyFieldConfigType = {
    text: 'text',
    phone: 'phone',
    email: 'email',
    radio: 'radio',
    checkbox: 'checkbox',
    textarea: 'textarea',
    select: 'select',
    number: 'number',
    rating: 'rating',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyThemeFontStyle = {
    fun: 'fun',
    formal: 'formal',
    modern: 'modern',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConvertSurveyRequestFormat = {
    auto: 'auto',
    word: 'word',
    excel: 'excel',
    text: 'text',
    markdown: 'markdown',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConvertSurveyRequestModel = {
    'gpt-4o': 'gpt-4o',
    'gpt-4o-mini': 'gpt-4o-mini',
    'gpt-4-turbo': 'gpt-4-turbo',
    'gpt-4': 'gpt-4',
    'gpt-35-turbo': 'gpt-3.5-turbo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiLogsErrorBodySeverity = {
    error: 'error',
    warning: 'warning',
    info: 'info',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiLogsClientBodyLogsItemLevel = {
    log: 'log',
    warn: 'warn',
    error: 'error',
    info: 'info',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiTestHyperdrive200ActualConnectionType = {
    HYPERDRIVE: 'HYPERDRIVE',
    DATABASE_URL: 'DATABASE_URL',
    UNKNOWN: 'UNKNOWN',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiTestHyperdrive500ActualConnectionType = {
    HYPERDRIVE: 'HYPERDRIVE',
    DATABASE_URL: 'DATABASE_URL',
    UNKNOWN: 'UNKNOWN',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiTestHyperdrive503ActualConnectionType = {
    HYPERDRIVE: 'HYPERDRIVE',
    DATABASE_URL: 'DATABASE_URL',
    UNKNOWN: 'UNKNOWN',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteAuthCheckGroupStatus200Status = {
    NOT_REGISTERED: 'NOT_REGISTERED',
    BOUND_TO_YOU: 'BOUND_TO_YOU',
    BOUND_TO_OTHER: 'BOUND_TO_OTHER',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteAuthGetPrepaidList200DataItemGender = {
    male: 'male',
    female: 'female',
    other: 'other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesCreateBodyStatus = {
    draft: 'draft',
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesUpdateBodyStatus = {
    draft: 'draft',
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesUpdateJoinItemBodyAction = {
    add: 'add',
    remove: 'remove',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesGetPrepaidInfo200DataGender = {
    male: 'male',
    female: 'female',
    other: 'other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesUpsertPrepaidInfoBodyGender = {
    male: 'male',
    female: 'female',
    other: 'other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteActivitiesUpsertPrepaidInfo200DataGender = {
    male: 'male',
    female: 'female',
    other: 'other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteSubscriptionStatus200PlanSlug = {
    free: 'free',
    trial: 'trial',
    basic: 'basic',
    plus: 'plus',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteSubscriptionPayBodyPlanSlug = {
    basic: 'basic',
    plus: 'plus',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteSubscriptionPayEcPayBodyPlanSlug = {
    basic: 'basic',
    plus: 'plus',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteSubscriptionPayEcPayBodyInvoiceInvoiceType = {
    personal: 'personal',
    company: 'company',
    donation: 'donation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiteSubscriptionPayEcPayBodyInvoiceCarrierType = {
    member: 'member',
    cellphone: 'cellphone',
    natural: 'natural',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetAuditLogsActorType = {
    super_admin: 'super_admin',
    member: 'member',
    staff: 'staff',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetTenantsSortBy = {
    name: 'name',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetTenantsSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetLiteGroupsPlan = {
    free: 'free',
    basic: 'basic',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetLiteGroupsSortBy = {
    name: 'name',
    created_at: 'created_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetLiteGroupsSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyFlexMessageType = {
    flex: 'flex',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignBubbleSize = {
    nano: 'nano',
    micro: 'micro',
    kilo: 'kilo',
    mega: 'mega',
    giga: 'giga',
    full: 'full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignScenario = {
    custom: 'custom',
    publish: 'publish',
    assistant: 'assistant',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminSendLiteAdBodyBubbleDesignBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminListLiteAdsPresetsScenario = {
    custom: 'custom',
    publish: 'publish',
    assistant: 'assistant',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminListLiteAdsPresetsSortBy = {
    created_at: 'created_at',
    name: 'name',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminListLiteAdsPresetsSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminListLiteAdsPresets200DataItemsItemBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminListLiteAdsPresets200DataItemsItemBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPresetBodyScenario = {
    custom: 'custom',
    publish: 'publish',
    assistant: 'assistant',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPresetBodyBubbleSize = {
    nano: 'nano',
    micro: 'micro',
    kilo: 'kilo',
    mega: 'mega',
    giga: 'giga',
    full: 'full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPresetBodyBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPresetBodyBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPreset200DataBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminCreateLiteAdsPreset200DataBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetLiteAdsPreset200DataBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminGetLiteAdsPreset200DataBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPresetBodyScenario = {
    custom: 'custom',
    publish: 'publish',
    assistant: 'assistant',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPresetBodyBubbleSize = {
    nano: 'nano',
    micro: 'micro',
    kilo: 'kilo',
    mega: 'mega',
    giga: 'giga',
    full: 'full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPresetBodyBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPresetBodyBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPreset200DataBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpdateLiteAdsPreset200DataBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPresetBodyScenario = {
    custom: 'custom',
    publish: 'publish',
    assistant: 'assistant',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPresetBodyBubbleSize = {
    nano: 'nano',
    micro: 'micro',
    kilo: 'kilo',
    mega: 'mega',
    giga: 'giga',
    full: 'full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPresetBodyBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPresetBodyBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPreset200DataBubblesItemHeroAspectRatio = {
    '20:13': '20:13',
    '1:1': '1:1',
    '151:1': '1.51:1',
    '191:1': '1.91:1',
    '4:3': '4:3',
    '16:9': '16:9',
    '2:1': '2:1',
    '3:1': '3:1',
    '3:4': '3:4',
    '9:16': '9:16',
    '1:2': '1:2',
    '1:3': '1:3',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperAdminUpsertLiteAdsPreset200DataBubblesItemHeroAspectMode = {
    cover: 'cover',
    fit: 'fit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCustomersSortBy = {
    id: 'id',
    name: 'name',
    phone: 'phone',
    created_at: 'created_at',
    updated_at: 'updated_at',
    last_purchase_at: 'last_purchase_at',
    current_month_spending: 'current_month_spending',
    last_month_spending: 'last_month_spending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCustomersIdCouponsOwned200DataItemDiscountType = {
    PERCENT: 'PERCENT',
    FIXED: 'FIXED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersGetPointsHistoryTransactionType = {
    EARN: 'EARN',
    REDEEM: 'REDEEM',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersGetPointsHistory200DataItemTransactionType = {
    EARN: 'EARN',
    REDEEM: 'REDEEM',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomersGetVouchers200DataItemStatus = {
    valid: 'valid',
    redeemed: 'redeemed',
    expired: 'expired',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomersGetPackages200DataItemStatus = {
    active: 'active',
    finished: 'finished',
    expired: 'expired',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomersGetPackages200ExpiredWarningsItemStatus = {
    active: 'active',
    finished: 'finished',
    expired: 'expired',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersGetByPhone200DataRole = {
    CLIENT: 'CLIENT',
    ADMIN: 'ADMIN',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersGetAvailableCoupons200DataItemDiscountType = {
    PERCENT: 'PERCENT',
    FIXED: 'FIXED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffListSortBy = {
    id: 'id',
    name: 'name',
    status: 'status',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffListStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffList200DataItemStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffCreateBodyStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffCreate201DataStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffGetMe200DataStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffCreateMeBodyStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffCreateMe201DataStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffGet200DataStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffUpdateBodyStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffUpdate200DataStatus = {
    active: 'active',
    inactive: 'inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DevicesListSortBy = {
    id: 'id',
    device_id: 'device_id',
    device_name: 'device_name',
    created_at: 'created_at',
    updated_at: 'updated_at',
    last_used_at: 'last_used_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountsGetByUserId200DataItemProvider = {
    google: 'google',
    line: 'line',
    email: 'email',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountsGet200DataProvider = {
    google: 'google',
    line: 'line',
    email: 'email',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountsUpdate200DataProvider = {
    google: 'google',
    line: 'line',
    email: 'email',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountsCreateBodyProvider = {
    google: 'google',
    line: 'line',
    email: 'email',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountsCreate201DataProvider = {
    google: 'google',
    line: 'line',
    email: 'email',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersGetMe200DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersList200DataItemRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersCreateBodyRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersCreate201DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersGetByUserId200DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersUpdateBodyRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersUpdate200DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembersGetWithoutStaff200DataItemRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesCreateBodyRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesCreate201DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesCreate201DataStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesList200DataItemRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesList200DataItemStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesGetByCode200DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesGetByCode200DataStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesGet200DataRole = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    STAFF: 'STAFF',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvitesGet200DataStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsListSortBy = {
    id: 'id',
    sku: 'sku',
    name: 'name',
    category: 'category',
    list_price_twd: 'list_price_twd',
    unit_price_twd: 'unit_price_twd',
    created_at: 'created_at',
    updated_at: 'updated_at',
    current_month_sales: 'current_month_sales',
    last_month_sales: 'last_month_sales',
    stock_quantity: 'stock_quantity',
    safety_stock: 'safety_stock',
    avg_cost: 'avg_cost',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsListType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsList200DataItemType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsList200DataItemRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsCreateBodyType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsCreateBodyRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsCreate201DataType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsCreate201DataRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsGet200DataType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsGet200DataRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsUpdateBodyType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsUpdateBodyRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsUpdate200DataType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsUpdate200DataRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsGetBySku200DataProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
    bundle: 'bundle',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductsGetBySku200DataProductRecommendationBadge = {
    chef_hat: 'chef_hat',
    thumbs_up: 'thumbs_up',
    star: 'star',
    flame: 'flame',
    crown: 'crown',
    new: 'new',
    leaf: 'leaf',
    fork_knife: 'fork_knife',
    medal: 'medal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountsListSortBy = {
    id: 'id',
    name: 'name',
    rule_type: 'rule_type',
    start_date: 'start_date',
    end_date: 'end_date',
    is_active: 'is_active',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountsListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountsCreateBodyChannelRestriction = {
    all: 'all',
    in_store: 'in_store',
    delivery: 'delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountsUpdateBodyChannelRestriction = {
    all: 'all',
    in_store: 'in_store',
    delivery: 'delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsRulesListSortBy = {
    id: 'id',
    name: 'name',
    points_per_yuan: 'points_per_yuan',
    target_type: 'target_type',
    start_date: 'start_date',
    end_date: 'end_date',
    is_active: 'is_active',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsRulesListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberLevelsListSortBy = {
    id: 'id',
    name: 'name',
    threshold_amount: 'threshold_amount',
    discount_rate_bps: 'discount_rate_bps',
    sort_order: 'sort_order',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberLevelsListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailabilitiesListSortBy = {
    day_of_week: 'day_of_week',
    start_time: 'start_time',
    created_at: 'created_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailabilitiesListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponsListSortBy = {
    name: 'name',
    coupon_type: 'coupon_type',
    trigger_type: 'trigger_type',
    starts_at: 'starts_at',
    ends_at: 'ends_at',
    is_active: 'is_active',
    created_at: 'created_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponsListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponsCreateBodyChannelRestriction = {
    all: 'all',
    in_store: 'in_store',
    delivery: 'delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CouponsUpdateBodyChannelRestriction = {
    all: 'all',
    in_store: 'in_store',
    delivery: 'delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersListSortBy = {
    id: 'id',
    order_number: 'order_number',
    user_id: 'user_id',
    subtotal_twd: 'subtotal_twd',
    discount_twd: 'discount_twd',
    total_twd: 'total_twd',
    status: 'status',
    channel: 'channel',
    takeaway_number: 'takeaway_number',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersListStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersListChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersList200DataItemStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersList200DataItemChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCreateBodyChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCreate201DataStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCreate201DataChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCreate201DataOrderItemsItemProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCreate201DataInvoiceStatus = {
    issued: 'issued',
    voided: 'voided',
    invalid: 'invalid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGet200DataStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGet200DataChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGet200DataOrderItemsItemProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGet200DataInvoiceStatus = {
    issued: 'issued',
    voided: 'voided',
    invalid: 'invalid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatusBodyOrderStatus = {
    成立: '成立',
    作廢: '作廢',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatusBodyPaymentStatus = {
    已付款: '已付款',
    待付款: '待付款',
    未付款: '未付款',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatusBodyStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatus200DataStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatus200DataChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatus200DataOrderItemsItemProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersUpdateStatus200DataInvoiceStatus = {
    issued: 'issued',
    voided: 'voided',
    invalid: 'invalid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCancel200DataStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCancel200DataChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCancel200DataOrderItemsItemProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersCancel200DataInvoiceStatus = {
    issued: 'issued',
    voided: 'voided',
    invalid: 'invalid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByNumber200DataStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByNumber200DataChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByNumber200DataOrderItemsItemProductType = {
    physical: 'physical',
    service: 'service',
    voucher: 'voucher',
    subscription: 'subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByNumber200DataInvoiceStatus = {
    issued: 'issued',
    voided: 'voided',
    invalid: 'invalid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByUserSortBy = {
    id: 'id',
    order_number: 'order_number',
    user_id: 'user_id',
    subtotal_twd: 'subtotal_twd',
    discount_twd: 'discount_twd',
    total_twd: 'total_twd',
    status: 'status',
    channel: 'channel',
    takeaway_number: 'takeaway_number',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByUserStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByUserChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByUser200DataItemStatus = {
    created: 'created',
    confirmed: 'confirmed',
    paid: 'paid',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrdersGetByUser200DataItemChannel = {
    店消: '店消',
    preorder: 'preorder',
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentsListSortBy = {
    id: 'id',
    start_time: 'start_time',
    end_time: 'end_time',
    status: 'status',
    created_at: 'created_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentsListSortDir = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentsListStatus = {
    scheduled: 'scheduled',
    checked_in: 'checked_in',
    cancelled: 'cancelled',
    no_show: 'no_show',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsListSortBy = {
    id: 'id',
    order_id: 'order_id',
    customer_id: 'customer_id',
    status: 'status',
    tracking_number: 'tracking_number',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsListStatus = {
    pending: 'pending',
    processing: 'processing',
    shipped: 'shipped',
    delivered: 'delivered',
    picked_up: 'picked_up',
    returned: 'returned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsList200DataItemStatus = {
    pending: 'pending',
    processing: 'processing',
    shipped: 'shipped',
    delivered: 'delivered',
    picked_up: 'picked_up',
    returned: 'returned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsGet200DataStatus = {
    pending: 'pending',
    processing: 'processing',
    shipped: 'shipped',
    delivered: 'delivered',
    picked_up: 'picked_up',
    returned: 'returned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsUpdateBodyStatus = {
    pending: 'pending',
    processing: 'processing',
    shipped: 'shipped',
    delivered: 'delivered',
    picked_up: 'picked_up',
    returned: 'returned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuppliersListSortBy = {
    id: 'id',
    name: 'name',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InventoryLogsType = {
    PURCHASE_IN: 'PURCHASE_IN',
    SALE_OUT: 'SALE_OUT',
    RETURN_IN: 'RETURN_IN',
    ADJUSTMENT: 'ADJUSTMENT',
    DAMAGE: 'DAMAGE',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InventoryLogs200DataItemType = {
    PURCHASE_IN: 'PURCHASE_IN',
    SALE_OUT: 'SALE_OUT',
    RETURN_IN: 'RETURN_IN',
    ADJUSTMENT: 'ADJUSTMENT',
    DAMAGE: 'DAMAGE',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersListSortBy = {
    id: 'id',
    supplier_id: 'supplier_id',
    status: 'status',
    total_amount: 'total_amount',
    received_date: 'received_date',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersListStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersList200DataItemStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersCreate201DataStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersGet200DataStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersUpdate200DataStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersReceive200DataStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrdersCancel200DataStatus = {
    draft: 'draft',
    ordered: 'ordered',
    received: 'received',
    cancelled: 'cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200Age = {
    '25歲以下': '25歲以下',
    '26-45歲': '26-45歲',
    '46歲以上': '46歲以上',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200Gender = {
    男: '男',
    女: '女',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200Location = {
    附近: '附近',
    外地: '外地',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200PurchaseFrequency = {
    每週3次以上: '每週3次以上',
    '每週1~3次': '每週1~3次',
    偶爾: '偶爾',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200PurchaseLocationItem = {
    麵包店: '麵包店',
    便利商店: '便利商店',
    量販超市: '量販超市',
    網購: '網購',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200PurchaseTime = {
    '早上(6:00~12:00)': '早上(6:00~12:00)',
    '下午(12:00~17:00)': '下午(12:00~17:00)',
    '晚上(17:00後)': '晚上(17:00後)',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200MealType = {
    早餐: '早餐',
    點心: '點心',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200PurchaseFactorsItem = {
    價格: '價格',
    健康: '健康',
    好吃: '好吃',
    口味嚐鮮: '口味嚐鮮',
    美觀: '美觀',
    衛生: '衛生',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200HealthPrice = {
    會: '會',
    不會: '不會',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200NaturalPreference = {
    在意: '在意',
    不在意: '不在意',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200TastePreferenceItem = {
    原味: '原味',
    鹹: '鹹',
    甜: '甜',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysCreate200BreadTypesItem = {
    吐司: '吐司',
    '台式、日式麵包': '台式、日式麵包',
    歐式麵包: '歐式麵包',
    法國麵包: '法國麵包',
    丹麥可頌: '丹麥可頌',
    貝果系列: '貝果系列',
    無麩質麵包: '無麩質麵包',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysListAge = {
    '25歲以下': '25歲以下',
    '26-45歲': '26-45歲',
    '46歲以上': '46歲以上',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysListGender = {
    男: '男',
    女: '女',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200Age = {
    '25歲以下': '25歲以下',
    '26-45歲': '26-45歲',
    '46歲以上': '46歲以上',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200Gender = {
    男: '男',
    女: '女',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200Location = {
    附近: '附近',
    外地: '外地',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200PurchaseFrequency = {
    每週3次以上: '每週3次以上',
    '每週1~3次': '每週1~3次',
    偶爾: '偶爾',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200PurchaseLocationItem = {
    麵包店: '麵包店',
    便利商店: '便利商店',
    量販超市: '量販超市',
    網購: '網購',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200PurchaseTime = {
    '早上(6:00~12:00)': '早上(6:00~12:00)',
    '下午(12:00~17:00)': '下午(12:00~17:00)',
    '晚上(17:00後)': '晚上(17:00後)',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200MealType = {
    早餐: '早餐',
    點心: '點心',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200PurchaseFactorsItem = {
    價格: '價格',
    健康: '健康',
    好吃: '好吃',
    口味嚐鮮: '口味嚐鮮',
    美觀: '美觀',
    衛生: '衛生',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200HealthPrice = {
    會: '會',
    不會: '不會',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200NaturalPreference = {
    在意: '在意',
    不在意: '不在意',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200TastePreferenceItem = {
    原味: '原味',
    鹹: '鹹',
    甜: '甜',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysGetByPhone200BreadTypesItem = {
    吐司: '吐司',
    '台式、日式麵包': '台式、日式麵包',
    歐式麵包: '歐式麵包',
    法國麵包: '法國麵包',
    丹麥可頌: '丹麥可頌',
    貝果系列: '貝果系列',
    無麩質麵包: '無麩質麵包',
    其他: '其他',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersAdminListSortBy = {
    starts_at: 'starts_at',
    created_at: 'created_at',
    updated_at: 'updated_at',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderBodyDeliveryMethod = {
    store_pickup: 'store_pickup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderBodyShippingAddressConvenienceStoreBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderBodyConvenienceStoreInfoBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyChannel = {
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyDeliveryMethod = {
    store_pickup: 'store_pickup',
    home_delivery: 'home_delivery',
    convenience_store_pickup: 'convenience_store_pickup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyPickupType = {
    dine_in: 'dine_in',
    takeout: 'takeout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyShippingAddressConvenienceStoreBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyConvenienceStoreInfoBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyInvoiceType = {
    personal: 'personal',
    company: 'company',
    donation: 'donation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyCarrierType = {
    member: 'member',
    cellphone: 'cellphone',
    natural: 'natural',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreordersCreateOrderForPaymentBodyPaymentType = {
    ecpay: 'ecpay',
    line_pay: 'line_pay',
    cvs_cod: 'cvs_cod',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyChannel = {
    online_order: 'online_order',
    online_shopping: 'online_shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyDeliveryMethod = {
    store_pickup: 'store_pickup',
    home_delivery: 'home_delivery',
    convenience_store_pickup: 'convenience_store_pickup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyPickupType = {
    dine_in: 'dine_in',
    takeout: 'takeout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyShippingAddressConvenienceStoreBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyConvenienceStoreInfoBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyInvoiceType = {
    personal: 'personal',
    company: 'company',
    donation: 'donation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyCarrierType = {
    member: 'member',
    cellphone: 'cellphone',
    natural: 'natural',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnlineOrdersCreateOrderForPaymentBodyPaymentType = {
    ecpay: 'ecpay',
    line_pay: 'line_pay',
    cvs_cod: 'cvs_cod',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsRequestPaymentBodyPaymentProvider = {
    line_pay: 'line_pay',
    ecpay: 'ecpay',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsRequestPaymentBodyEcpayChoosePayment = {
    ApplePay: 'ApplePay',
    LinePay: 'LinePay',
    TWQR: 'TWQR',
    GooglePay: 'GooglePay',
    Credit: 'Credit',
    ATM: 'ATM',
    CVS: 'CVS',
    BARCODE: 'BARCODE',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsRequestPayment200DataPaymentProvider = {
    line_pay: 'line_pay',
    ecpay: 'ecpay',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsConfirmLinePayBodyDeliveryMethod = {
    store_pickup: 'store_pickup',
    home_delivery: 'home_delivery',
    convenience_store_pickup: 'convenience_store_pickup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsConfirmLinePayBodyShippingAddressConvenienceStoreBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsConfirmLinePayBodyConvenienceStoreInfoBrand = {
    '7-ELEVEN': '7-ELEVEN',
    FamilyMart: 'FamilyMart',
    HiLife: 'HiLife',
    OK_MART: 'OK_MART',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContextResolve200Status = {
    bound: 'bound',
    unbound: 'unbound',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantSubscriptionStatus200PlanSlug = {
    free: 'free',
    basic: 'basic',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantSubscriptionPayBodyPlanSlug = {
    basic: 'basic',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantSubscriptionPayEcPayBodyPlanSlug = {
    basic: 'basic',
    pro: 'pro',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantSubscriptionPayEcPayBodyInvoiceInvoiceType = {
    personal: 'personal',
    company: 'company',
    donation: 'donation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantSubscriptionPayEcPayBodyInvoiceCarrierType = {
    member: 'member',
    cellphone: 'cellphone',
    natural: 'natural',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RAGUploadKnowledge201DataSourceType = {
    file: 'file',
    line: 'line',
    messenger: 'messenger',
    web: 'web',
    manual: 'manual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RAGCreateKnowledgeBodySourceType = {
    file: 'file',
    line: 'line',
    messenger: 'messenger',
    web: 'web',
    manual: 'manual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RAGCreateKnowledge201DataSourceType = {
    file: 'file',
    line: 'line',
    messenger: 'messenger',
    web: 'web',
    manual: 'manual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RAGListKnowledgeSourceType = {
    file: 'file',
    line: 'line',
    messenger: 'messenger',
    web: 'web',
    manual: 'manual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RAGListKnowledge200DataItemsItemSourceType = {
    file: 'file',
    line: 'line',
    messenger: 'messenger',
    web: 'web',
    manual: 'manual',
};
export const getGetHealthUrl = () => {
    return createFullURL(`/health`);
};
export const getHealth = async (options) => {
    const res = await fetch(getGetHealthUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetHealthKey = () => [`/health`];
/**
 * @summary 健康檢查
 */
export const useGetHealth = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetHealthKey() : null));
    const swrFn = () => getHealth(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetVersionUrl = () => {
    return createFullURL(`/version`);
};
export const getVersion = async (options) => {
    const res = await fetch(getGetVersionUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetVersionKey = () => [`/version`];
/**
 * @summary 版本資訊
 */
export const useGetVersion = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetVersionKey() : null));
    const swrFn = () => getVersion(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getBootstrapGetUrl = () => {
    return createFullURL(`/api/bootstrap`);
};
export const bootstrapGet = async (options) => {
    const res = await fetch(getBootstrapGetUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getBootstrapGetKey = () => [`/api/bootstrap`];
/**
 * @summary 登入後初始化資料
 */
export const useBootstrapGet = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getBootstrapGetKey() : null));
    const swrFn = () => bootstrapGet(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPublicGetToolStationVisibleUrl = () => {
    return createFullURL(`/api/public/tool-station-visible`);
};
export const publicGetToolStationVisible = async (options) => {
    const res = await fetch(getPublicGetToolStationVisibleUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPublicGetToolStationVisibleKey = () => [`/api/public/tool-station-visible`];
/**
 * @summary 取得工具站顯示清單
 */
export const usePublicGetToolStationVisible = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPublicGetToolStationVisibleKey() : null));
    const swrFn = () => publicGetToolStationVisible(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPublicGetToolUsageStatsUrl = (slug) => {
    return createFullURL(`/api/public/tool-usage/${slug}`);
};
export const publicGetToolUsageStats = async (slug, options) => {
    const res = await fetch(getPublicGetToolUsageStatsUrl(slug), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPublicGetToolUsageStatsKey = (slug) => [`/api/public/tool-usage/${slug}`];
/**
 * @summary 取得工具使用次數（CountAPI 代理）
 */
export const usePublicGetToolUsageStats = (slug, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!slug;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPublicGetToolUsageStatsKey(slug) : null));
    const swrFn = () => publicGetToolUsageStats(slug, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUploadsTenantImageUrl = (type) => {
    return createFullURL(`/api/uploads/tenants/${type}`);
};
export const uploadsTenantImage = async (type, uploadsTenantImageBody, options) => {
    const formData = new FormData();
    if (uploadsTenantImageBody.file !== undefined &&
        uploadsTenantImageBody.file !== null &&
        typeof uploadsTenantImageBody.file === 'object' &&
        uploadsTenantImageBody.file instanceof Blob) {
        formData.append(`file`, uploadsTenantImageBody.file);
    }
    const res = await fetch(getUploadsTenantImageUrl(type), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUploadsTenantImageMutationFetcher = (type, options) => {
    return (_, { arg }) => {
        return uploadsTenantImage(type, arg, options);
    };
};
export const getUploadsTenantImageMutationKey = (type) => [`/api/uploads/tenants/${type}`];
/**
 * @summary 上傳商家圖片
 */
export const useUploadsTenantImage = (type, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getUploadsTenantImageMutationKey(type);
    const swrFn = getUploadsTenantImageMutationFetcher(type, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUploadsCampaignImageUrl = () => {
    return createFullURL(`/api/uploads/campaigns`);
};
export const uploadsCampaignImage = async (uploadsCampaignImageBody, options) => {
    const formData = new FormData();
    if (uploadsCampaignImageBody.file !== undefined &&
        uploadsCampaignImageBody.file !== null &&
        typeof uploadsCampaignImageBody.file === 'object' &&
        uploadsCampaignImageBody.file instanceof Blob) {
        formData.append(`file`, uploadsCampaignImageBody.file);
    }
    const res = await fetch(getUploadsCampaignImageUrl(), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUploadsCampaignImageMutationFetcher = (options) => {
    return (_, { arg }) => {
        return uploadsCampaignImage(arg, options);
    };
};
export const getUploadsCampaignImageMutationKey = () => [`/api/uploads/campaigns`];
/**
 * @summary 上傳預購活動橫幅圖
 */
export const useUploadsCampaignImage = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getUploadsCampaignImageMutationKey();
    const swrFn = getUploadsCampaignImageMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUploadsProductImageLocalUrl = () => {
    return createFullURL(`/api/uploads/products`);
};
export const uploadsProductImageLocal = async (uploadsProductImageLocalBody, options) => {
    const formData = new FormData();
    if (uploadsProductImageLocalBody.file !== undefined &&
        uploadsProductImageLocalBody.file !== null &&
        typeof uploadsProductImageLocalBody.file === 'object' &&
        uploadsProductImageLocalBody.file instanceof Blob) {
        formData.append(`file`, uploadsProductImageLocalBody.file);
    }
    const res = await fetch(getUploadsProductImageLocalUrl(), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUploadsProductImageLocalMutationFetcher = (options) => {
    return (_, { arg }) => {
        return uploadsProductImageLocal(arg, options);
    };
};
export const getUploadsProductImageLocalMutationKey = () => [`/api/uploads/products`];
/**
 * @summary 上傳產品圖片
 */
export const useUploadsProductImageLocal = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getUploadsProductImageLocalMutationKey();
    const swrFn = getUploadsProductImageLocalMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAssetsGetFileLocalUrl = () => {
    return createFullURL(`/assets/*`);
};
export const assetsGetFileLocal = async (options) => {
    const res = await fetch(getAssetsGetFileLocalUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAssetsGetFileLocalKey = () => [`/assets/*`];
/**
 * @summary 取得檔案
 */
export const useAssetsGetFileLocal = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAssetsGetFileLocalKey() : null));
    const swrFn = () => assetsGetFileLocal(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAssetsDeleteFileUrl = () => {
    return createFullURL(`/assets/*`);
};
export const assetsDeleteFile = async (options) => {
    const res = await fetch(getAssetsDeleteFileUrl(), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAssetsDeleteFileMutationFetcher = (options) => {
    return (_, __) => {
        return assetsDeleteFile(options);
    };
};
export const getAssetsDeleteFileMutationKey = () => [`/assets/*`];
/**
 * @summary 刪除檔案
 */
export const useAssetsDeleteFile = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAssetsDeleteFileMutationKey();
    const swrFn = getAssetsDeleteFileMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiDataUrl = () => {
    return createFullURL(`/api/data`);
};
export const getApiData = async (options) => {
    const res = await fetch(getGetApiDataUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiDataKey = () => [`/api/data`];
/**
 * @summary 取得各表資料摘要
 */
export const useGetApiData = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetApiDataKey() : null));
    const swrFn = () => getApiData(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiLogsErrorUrl = () => {
    return createFullURL(`/api/logs/error`);
};
export const postApiLogsError = async (postApiLogsErrorBody, options) => {
    const res = await fetch(getPostApiLogsErrorUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiLogsErrorBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiLogsErrorMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiLogsError(arg, options);
    };
};
export const getPostApiLogsErrorMutationKey = () => [`/api/logs/error`];
/**
 * @summary 接收前端錯誤日誌
 */
export const usePostApiLogsError = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiLogsErrorMutationKey();
    const swrFn = getPostApiLogsErrorMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiLogsClientUrl = () => {
    return createFullURL(`/api/logs/client`);
};
export const postApiLogsClient = async (postApiLogsClientBody, options) => {
    const res = await fetch(getPostApiLogsClientUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiLogsClientBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiLogsClientMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiLogsClient(arg, options);
    };
};
export const getPostApiLogsClientMutationKey = () => [`/api/logs/client`];
/**
 * @summary 接收前端客戶端日誌
 */
export const usePostApiLogsClient = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiLogsClientMutationKey();
    const swrFn = getPostApiLogsClientMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiTestHyperdriveUrl = () => {
    return createFullURL(`/api/test/hyperdrive`);
};
export const getApiTestHyperdrive = async (options) => {
    const res = await fetch(getGetApiTestHyperdriveUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiTestHyperdriveKey = () => [`/api/test/hyperdrive`];
/**
 * @summary 測試 Hyperdrive 連接
 */
export const useGetApiTestHyperdrive = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiTestHyperdriveKey() : null));
    const swrFn = () => getApiTestHyperdrive(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsGetActiveAnnouncementsUrl = () => {
    return createFullURL(`/api/tenants/announcements/active`);
};
export const tenantsGetActiveAnnouncements = async (options) => {
    const res = await fetch(getTenantsGetActiveAnnouncementsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsGetActiveAnnouncementsKey = () => [`/api/tenants/announcements/active`];
/**
 * @summary 取得當前有效租戶公告
 */
export const useTenantsGetActiveAnnouncements = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getTenantsGetActiveAnnouncementsKey() : null));
    const swrFn = () => tenantsGetActiveAnnouncements(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthLoginUrl = () => {
    return createFullURL(`/api/lite/auth/register`);
};
export const liteAuthLogin = async (liteAuthLoginBody, options) => {
    const res = await fetch(getLiteAuthLoginUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteAuthLoginBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthLoginMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteAuthLogin(arg, options);
    };
};
export const getLiteAuthLoginMutationKey = () => [`/api/lite/auth/register`];
/**
 * @summary 登入/認證 Lite 用戶
 */
export const useLiteAuthLogin = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthLoginMutationKey();
    const swrFn = getLiteAuthLoginMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthLoginWithTenantUrl = () => {
    return createFullURL(`/api/lite/auth/register-with-tenant`);
};
export const liteAuthLoginWithTenant = async (liteAuthLoginWithTenantBody, options) => {
    const res = await fetch(getLiteAuthLoginWithTenantUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteAuthLoginWithTenantBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthLoginWithTenantMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteAuthLoginWithTenant(arg, options);
    };
};
export const getLiteAuthLoginWithTenantMutationKey = () => [`/api/lite/auth/register-with-tenant`];
/**
 * @summary 登入/認證用戶並建立租戶
 */
export const useLiteAuthLoginWithTenant = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthLoginWithTenantMutationKey();
    const swrFn = getLiteAuthLoginWithTenantMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthGetMeUrl = () => {
    return createFullURL(`/api/lite/auth/me`);
};
export const liteAuthGetMe = async (options) => {
    const res = await fetch(getLiteAuthGetMeUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthGetMeKey = () => [`/api/lite/auth/me`];
/**
 * @summary 取得當前 Lite 用戶資訊
 */
export const useLiteAuthGetMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getLiteAuthGetMeKey() : null));
    const swrFn = () => liteAuthGetMe(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthSwitchSquareUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/switch-square?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/switch-square`);
};
export const liteAuthSwitchSquare = async (params, options) => {
    const res = await fetch(getLiteAuthSwitchSquareUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthSwitchSquareKey = (params) => [`/api/lite/auth/switch-square`, ...(params ? [params] : [])];
/**
 * @summary 依 Square 換發 JWT
 */
export const useLiteAuthSwitchSquare = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthSwitchSquareKey(params) : null));
    const swrFn = () => liteAuthSwitchSquare(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthCheckGroupTenantUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/check-group?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/check-group`);
};
export const liteAuthCheckGroupTenant = async (params, options) => {
    const res = await fetch(getLiteAuthCheckGroupTenantUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthCheckGroupTenantKey = (params) => [`/api/lite/auth/check-group`, ...(params ? [params] : [])];
/**
 * @summary 檢查群組的 tenant 狀態
 */
export const useLiteAuthCheckGroupTenant = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthCheckGroupTenantKey(params) : null));
    const swrFn = () => liteAuthCheckGroupTenant(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthCheckGroupStatusUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/check-group-status?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/check-group-status`);
};
export const liteAuthCheckGroupStatus = async (params, options) => {
    const res = await fetch(getLiteAuthCheckGroupStatusUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthCheckGroupStatusKey = (params) => [`/api/lite/auth/check-group-status`, ...(params ? [params] : [])];
/**
 * @summary 檢查群組狀態（JWT 認證）
 */
export const useLiteAuthCheckGroupStatus = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthCheckGroupStatusKey(params) : null));
    const swrFn = () => liteAuthCheckGroupStatus(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthUpdateGroupSettingsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/group-settings?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/group-settings`);
};
export const liteAuthUpdateGroupSettings = async (liteAuthUpdateGroupSettingsBody, params, options) => {
    const res = await fetch(getLiteAuthUpdateGroupSettingsUrl(params), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteAuthUpdateGroupSettingsBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthUpdateGroupSettingsMutationFetcher = (params, options) => {
    return (_, { arg }) => {
        return liteAuthUpdateGroupSettings(arg, params, options);
    };
};
export const getLiteAuthUpdateGroupSettingsMutationKey = (params) => [`/api/lite/auth/group-settings`, ...(params ? [params] : [])];
/**
 * @summary 更新群組設定
 */
export const useLiteAuthUpdateGroupSettings = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthUpdateGroupSettingsMutationKey(params);
    const swrFn = getLiteAuthUpdateGroupSettingsMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthGetSquareSettingsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/square-settings?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/square-settings`);
};
export const liteAuthGetSquareSettings = async (params, options) => {
    const res = await fetch(getLiteAuthGetSquareSettingsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthGetSquareSettingsKey = (params) => [`/api/lite/auth/square-settings`, ...(params ? [params] : [])];
/**
 * @summary 取得 Square 設定
 */
export const useLiteAuthGetSquareSettings = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthGetSquareSettingsKey(params) : null));
    const swrFn = () => liteAuthGetSquareSettings(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthUpdateSquareSettingsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/square-settings?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/square-settings`);
};
export const liteAuthUpdateSquareSettings = async (liteAuthUpdateSquareSettingsBody, params, options) => {
    const res = await fetch(getLiteAuthUpdateSquareSettingsUrl(params), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteAuthUpdateSquareSettingsBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthUpdateSquareSettingsMutationFetcher = (params, options) => {
    return (_, { arg }) => {
        return liteAuthUpdateSquareSettings(arg, params, options);
    };
};
export const getLiteAuthUpdateSquareSettingsMutationKey = (params) => [`/api/lite/auth/square-settings`, ...(params ? [params] : [])];
/**
 * @summary 更新 Square 設定
 */
export const useLiteAuthUpdateSquareSettings = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthUpdateSquareSettingsMutationKey(params);
    const swrFn = getLiteAuthUpdateSquareSettingsMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthUploadFlexCoverUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/upload-flex-cover?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/upload-flex-cover`);
};
export const liteAuthUploadFlexCover = async (liteAuthUploadFlexCoverBody, params, options) => {
    const formData = new FormData();
    if (liteAuthUploadFlexCoverBody.file !== undefined &&
        liteAuthUploadFlexCoverBody.file !== null &&
        typeof liteAuthUploadFlexCoverBody.file === 'object' &&
        liteAuthUploadFlexCoverBody.file instanceof Blob) {
        formData.append(`file`, liteAuthUploadFlexCoverBody.file);
    }
    const res = await fetch(getLiteAuthUploadFlexCoverUrl(params), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthUploadFlexCoverMutationFetcher = (params, options) => {
    return (_, { arg }) => {
        return liteAuthUploadFlexCover(arg, params, options);
    };
};
export const getLiteAuthUploadFlexCoverMutationKey = (params) => [`/api/lite/auth/upload-flex-cover`, ...(params ? [params] : [])];
/**
 * @summary 上傳 Flex 封面圖
 */
export const useLiteAuthUploadFlexCover = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthUploadFlexCoverMutationKey(params);
    const swrFn = getLiteAuthUploadFlexCoverMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthUnbindGroupUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/unbind-group?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/unbind-group`);
};
export const liteAuthUnbindGroup = async (params, options) => {
    const res = await fetch(getLiteAuthUnbindGroupUrl(params), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthUnbindGroupMutationFetcher = (params, options) => {
    return (_, __) => {
        return liteAuthUnbindGroup(params, options);
    };
};
export const getLiteAuthUnbindGroupMutationKey = (params) => [`/api/lite/auth/unbind-group`, ...(params ? [params] : [])];
/**
 * @summary 解除群組綁定
 */
export const useLiteAuthUnbindGroup = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthUnbindGroupMutationKey(params);
    const swrFn = getLiteAuthUnbindGroupMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthBindGroupWithSquareUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/bind-group-with-square?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/bind-group-with-square`);
};
export const liteAuthBindGroupWithSquare = async (liteAuthBindGroupWithSquareBody, params, options) => {
    const res = await fetch(getLiteAuthBindGroupWithSquareUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteAuthBindGroupWithSquareBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthBindGroupWithSquareMutationFetcher = (params, options) => {
    return (_, { arg }) => {
        return liteAuthBindGroupWithSquare(arg, params, options);
    };
};
export const getLiteAuthBindGroupWithSquareMutationKey = (params) => [
    `/api/lite/auth/bind-group-with-square`,
    ...(params ? [params] : []),
];
/**
 * @summary 將群組綁定到現有 Square
 */
export const useLiteAuthBindGroupWithSquare = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthBindGroupWithSquareMutationKey(params);
    const swrFn = getLiteAuthBindGroupWithSquareMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthGetPrepaidListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/prepaid-list?${stringifiedParams}`)
        : createFullURL(`/api/lite/prepaid-list`);
};
export const liteAuthGetPrepaidList = async (params, options) => {
    const res = await fetch(getLiteAuthGetPrepaidListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthGetPrepaidListKey = (params) => [`/api/lite/prepaid-list`, ...(params ? [params] : [])];
/**
 * @summary 取得預繳名單
 */
export const useLiteAuthGetPrepaidList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthGetPrepaidListKey(params) : null));
    const swrFn = () => liteAuthGetPrepaidList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthDeleteShopUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/delete-shop?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/delete-shop`);
};
export const liteAuthDeleteShop = async (params, options) => {
    const res = await fetch(getLiteAuthDeleteShopUrl(params), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthDeleteShopMutationFetcher = (params, options) => {
    return (_, __) => {
        return liteAuthDeleteShop(params, options);
    };
};
export const getLiteAuthDeleteShopMutationKey = (params) => [`/api/lite/auth/delete-shop`, ...(params ? [params] : [])];
/**
 * @summary 刪除商家
 */
export const useLiteAuthDeleteShop = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteAuthDeleteShopMutationKey(params);
    const swrFn = getLiteAuthDeleteShopMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthLineLoginRedirectUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/line?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/line`);
};
export const liteAuthLineLoginRedirect = async (params, options) => {
    const res = await fetch(getLiteAuthLineLoginRedirectUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthLineLoginRedirectKey = (params) => [`/api/lite/auth/line`, ...(params ? [params] : [])];
/**
 * @summary 導向 LINE Login 授權頁（Lite Square 用）
 */
export const useLiteAuthLineLoginRedirect = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthLineLoginRedirectKey(params) : null));
    const swrFn = () => liteAuthLineLoginRedirect(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAuthLineLoginCallbackUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/auth/line/callback?${stringifiedParams}`)
        : createFullURL(`/api/lite/auth/line/callback`);
};
export const liteAuthLineLoginCallback = async (params, options) => {
    const res = await fetch(getLiteAuthLineLoginCallbackUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAuthLineLoginCallbackKey = (params) => [`/api/lite/auth/line/callback`, ...(params ? [params] : [])];
/**
 * @summary LINE OAuth callback（Lite Square 註冊/登入）
 */
export const useLiteAuthLineLoginCallback = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAuthLineLoginCallbackKey(params) : null));
    const swrFn = () => liteAuthLineLoginCallback(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesRecognizeImageUrl = () => {
    return createFullURL(`/api/lite/activities/recognize-image`);
};
export const liteActivitiesRecognizeImage = async (liteActivitiesRecognizeImageBody, options) => {
    const formData = new FormData();
    if (liteActivitiesRecognizeImageBody.images !== undefined &&
        liteActivitiesRecognizeImageBody.images !== null) {
        const images = Array.isArray(liteActivitiesRecognizeImageBody.images)
            ? liteActivitiesRecognizeImageBody.images
            : [liteActivitiesRecognizeImageBody.images];
        for (const file of images) {
            if (file instanceof Blob)
                formData.append('images', file);
        }
    }
    const res = await fetch(getLiteActivitiesRecognizeImageUrl(), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesRecognizeImageMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteActivitiesRecognizeImage(arg, options);
    };
};
export const getLiteActivitiesRecognizeImageMutationKey = () => [`/api/lite/activities/recognize-image`];
/**
 * @summary 菜單辨識
 */
export const useLiteActivitiesRecognizeImage = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesRecognizeImageMutationKey();
    const swrFn = getLiteActivitiesRecognizeImageMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesCreateUrl = () => {
    return createFullURL(`/api/lite/activities`);
};
export const liteActivitiesCreate = async (liteActivitiesCreateBody, options) => {
    const res = await fetch(getLiteActivitiesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteActivitiesCreate(arg, options);
    };
};
export const getLiteActivitiesCreateMutationKey = () => [`/api/lite/activities`];
/**
 * @summary 建立新活動
 */
export const useLiteActivitiesCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesCreateMutationKey();
    const swrFn = getLiteActivitiesCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/activities?${stringifiedParams}`)
        : createFullURL(`/api/lite/activities`);
};
export const liteActivitiesList = async (params, options) => {
    const res = await fetch(getLiteActivitiesListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesListKey = (params) => [`/api/lite/activities`, ...(params ? [params] : [])];
/**
 * @summary 取得活動列表
 */
export const useLiteActivitiesList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesListKey(params) : null));
    const swrFn = () => liteActivitiesList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesGetUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}`);
};
export const liteActivitiesGet = async (id, options) => {
    const res = await fetch(getLiteActivitiesGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesGetKey = (id) => [`/api/lite/activities/${id}`];
/**
 * @summary 取得單一活動
 */
export const useLiteActivitiesGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesGetKey(id) : null));
    const swrFn = () => liteActivitiesGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpdateUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}`);
};
export const liteActivitiesUpdate = async (id, liteActivitiesUpdateBody, options) => {
    const res = await fetch(getLiteActivitiesUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpdate(id, arg, options);
    };
};
export const getLiteActivitiesUpdateMutationKey = (id) => [`/api/lite/activities/${id}`];
/**
 * @summary 更新活動
 */
export const useLiteActivitiesUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesUpdateMutationKey(id);
    const swrFn = getLiteActivitiesUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesRemoveUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}`);
};
export const liteActivitiesRemove = async (id, options) => {
    const res = await fetch(getLiteActivitiesRemoveUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesRemoveMutationFetcher = (id, options) => {
    return (_, __) => {
        return liteActivitiesRemove(id, options);
    };
};
export const getLiteActivitiesRemoveMutationKey = (id) => [`/api/lite/activities/${id}`];
/**
 * @summary 移除活動
 */
export const useLiteActivitiesRemove = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesRemoveMutationKey(id);
    const swrFn = getLiteActivitiesRemoveMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesGetJoinUrl = (activityId) => {
    return createFullURL(`/api/lite/join/${activityId}`);
};
export const liteActivitiesGetJoin = async (activityId, options) => {
    const res = await fetch(getLiteActivitiesGetJoinUrl(activityId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesGetJoinKey = (activityId) => [`/api/lite/join/${activityId}`];
/**
 * @summary 取得活動資訊（Join 頁面）
 */
export const useLiteActivitiesGetJoin = (activityId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!activityId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesGetJoinKey(activityId) : null));
    const swrFn = () => liteActivitiesGetJoin(activityId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesAddWaitlistUrl = (activityId) => {
    return createFullURL(`/api/lite/activities/${activityId}/waitlist`);
};
export const liteActivitiesAddWaitlist = async (activityId, liteActivitiesAddWaitlistBody, options) => {
    const res = await fetch(getLiteActivitiesAddWaitlistUrl(activityId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesAddWaitlistBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesAddWaitlistMutationFetcher = (activityId, options) => {
    return (_, { arg }) => {
        return liteActivitiesAddWaitlist(activityId, arg, options);
    };
};
export const getLiteActivitiesAddWaitlistMutationKey = (activityId) => [`/api/lite/activities/${activityId}/waitlist`];
/**
 * @summary 登記後補
 */
export const useLiteActivitiesAddWaitlist = (activityId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesAddWaitlistMutationKey(activityId);
    const swrFn = getLiteActivitiesAddWaitlistMutationFetcher(activityId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpdateJoinItemUrl = (activityId) => {
    return createFullURL(`/api/lite/join/${activityId}/items`);
};
export const liteActivitiesUpdateJoinItem = async (activityId, liteActivitiesUpdateJoinItemBody, options) => {
    const res = await fetch(getLiteActivitiesUpdateJoinItemUrl(activityId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpdateJoinItemBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpdateJoinItemMutationFetcher = (activityId, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpdateJoinItem(activityId, arg, options);
    };
};
export const getLiteActivitiesUpdateJoinItemMutationKey = (activityId) => [`/api/lite/join/${activityId}/items`];
/**
 * @summary 更新用戶商品選擇（Join 頁面）
 */
export const useLiteActivitiesUpdateJoinItem = (activityId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getLiteActivitiesUpdateJoinItemMutationKey(activityId);
    const swrFn = getLiteActivitiesUpdateJoinItemMutationFetcher(activityId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpdateJoinRemarksUrl = (activityId) => {
    return createFullURL(`/api/lite/join/${activityId}/remarks`);
};
export const liteActivitiesUpdateJoinRemarks = async (activityId, liteActivitiesUpdateJoinRemarksBody, options) => {
    const res = await fetch(getLiteActivitiesUpdateJoinRemarksUrl(activityId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpdateJoinRemarksBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpdateJoinRemarksMutationFetcher = (activityId, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpdateJoinRemarks(activityId, arg, options);
    };
};
export const getLiteActivitiesUpdateJoinRemarksMutationKey = (activityId) => [`/api/lite/join/${activityId}/remarks`];
/**
 * @summary 更新參與備註
 */
export const useLiteActivitiesUpdateJoinRemarks = (activityId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getLiteActivitiesUpdateJoinRemarksMutationKey(activityId);
    const swrFn = getLiteActivitiesUpdateJoinRemarksMutationFetcher(activityId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpdateJoinDisplayNameUrl = (activityId) => {
    return createFullURL(`/api/lite/join/${activityId}/display-name`);
};
export const liteActivitiesUpdateJoinDisplayName = async (activityId, liteActivitiesUpdateJoinDisplayNameBody, options) => {
    const res = await fetch(getLiteActivitiesUpdateJoinDisplayNameUrl(activityId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpdateJoinDisplayNameBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpdateJoinDisplayNameMutationFetcher = (activityId, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpdateJoinDisplayName(activityId, arg, options);
    };
};
export const getLiteActivitiesUpdateJoinDisplayNameMutationKey = (activityId) => [`/api/lite/join/${activityId}/display-name`];
/**
 * @summary 更新暱稱
 */
export const useLiteActivitiesUpdateJoinDisplayName = (activityId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getLiteActivitiesUpdateJoinDisplayNameMutationKey(activityId);
    const swrFn = getLiteActivitiesUpdateJoinDisplayNameMutationFetcher(activityId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesSettleUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}/settle`);
};
export const liteActivitiesSettle = async (id, options) => {
    const res = await fetch(getLiteActivitiesSettleUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesSettleMutationFetcher = (id, options) => {
    return (_, __) => {
        return liteActivitiesSettle(id, options);
    };
};
export const getLiteActivitiesSettleMutationKey = (id) => [`/api/lite/activities/${id}/settle`];
/**
 * @summary 結束活動
 */
export const useLiteActivitiesSettle = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesSettleMutationKey(id);
    const swrFn = getLiteActivitiesSettleMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesGetResultUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}/result`);
};
export const liteActivitiesGetResult = async (id, options) => {
    const res = await fetch(getLiteActivitiesGetResultUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesGetResultKey = (id) => [`/api/lite/activities/${id}/result`];
/**
 * @summary 取得活動結果
 */
export const useLiteActivitiesGetResult = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesGetResultKey(id) : null));
    const swrFn = () => liteActivitiesGetResult(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesGetPrepaidInfoUrl = (id, userId) => {
    return createFullURL(`/api/lite/activities/${id}/prepaid/${userId}`);
};
export const liteActivitiesGetPrepaidInfo = async (id, userId, options) => {
    const res = await fetch(getLiteActivitiesGetPrepaidInfoUrl(id, userId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesGetPrepaidInfoKey = (id, userId) => [`/api/lite/activities/${id}/prepaid/${userId}`];
/**
 * @summary 取得預繳資訊
 */
export const useLiteActivitiesGetPrepaidInfo = (id, userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!(id && userId);
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesGetPrepaidInfoKey(id, userId) : null));
    const swrFn = () => liteActivitiesGetPrepaidInfo(id, userId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpsertPrepaidInfoUrl = (id, userId) => {
    return createFullURL(`/api/lite/activities/${id}/prepaid/${userId}`);
};
export const liteActivitiesUpsertPrepaidInfo = async (id, userId, liteActivitiesUpsertPrepaidInfoBody, options) => {
    const res = await fetch(getLiteActivitiesUpsertPrepaidInfoUrl(id, userId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpsertPrepaidInfoBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpsertPrepaidInfoMutationFetcher = (id, userId, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpsertPrepaidInfo(id, userId, arg, options);
    };
};
export const getLiteActivitiesUpsertPrepaidInfoMutationKey = (id, userId) => [`/api/lite/activities/${id}/prepaid/${userId}`];
/**
 * @summary 更新預繳資訊
 */
export const useLiteActivitiesUpsertPrepaidInfo = (id, userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getLiteActivitiesUpsertPrepaidInfoMutationKey(id, userId);
    const swrFn = getLiteActivitiesUpsertPrepaidInfoMutationFetcher(id, userId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesUpdateDeliveryStatusUrl = (id, itemId) => {
    return createFullURL(`/api/lite/activities/${id}/items/${itemId}/delivery`);
};
export const liteActivitiesUpdateDeliveryStatus = async (id, itemId, liteActivitiesUpdateDeliveryStatusBody, options) => {
    const res = await fetch(getLiteActivitiesUpdateDeliveryStatusUrl(id, itemId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteActivitiesUpdateDeliveryStatusBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesUpdateDeliveryStatusMutationFetcher = (id, itemId, options) => {
    return (_, { arg }) => {
        return liteActivitiesUpdateDeliveryStatus(id, itemId, arg, options);
    };
};
export const getLiteActivitiesUpdateDeliveryStatusMutationKey = (id, itemId) => [`/api/lite/activities/${id}/items/${itemId}/delivery`];
/**
 * @summary 更新交付/棄單狀態
 */
export const useLiteActivitiesUpdateDeliveryStatus = (id, itemId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getLiteActivitiesUpdateDeliveryStatusMutationKey(id, itemId);
    const swrFn = getLiteActivitiesUpdateDeliveryStatusMutationFetcher(id, itemId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesGetStatisticsUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}/statistics`);
};
export const liteActivitiesGetStatistics = async (id, options) => {
    const res = await fetch(getLiteActivitiesGetStatisticsUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesGetStatisticsKey = (id) => [`/api/lite/activities/${id}/statistics`];
/**
 * @summary 取得活動統計
 */
export const useLiteActivitiesGetStatistics = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteActivitiesGetStatisticsKey(id) : null));
    const swrFn = () => liteActivitiesGetStatistics(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteActivitiesDuplicateUrl = (id) => {
    return createFullURL(`/api/lite/activities/${id}/duplicate`);
};
export const liteActivitiesDuplicate = async (id, options) => {
    const res = await fetch(getLiteActivitiesDuplicateUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteActivitiesDuplicateMutationFetcher = (id, options) => {
    return (_, __) => {
        return liteActivitiesDuplicate(id, options);
    };
};
export const getLiteActivitiesDuplicateMutationKey = (id) => [`/api/lite/activities/${id}/duplicate`];
/**
 * @summary 複製活動
 */
export const useLiteActivitiesDuplicate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteActivitiesDuplicateMutationKey(id);
    const swrFn = getLiteActivitiesDuplicateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteOrdersUpdateItemUrl = () => {
    return createFullURL(`/api/lite/orders/items`);
};
export const liteOrdersUpdateItem = async (liteOrdersUpdateItemBody, options) => {
    const res = await fetch(getLiteOrdersUpdateItemUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteOrdersUpdateItemBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteOrdersUpdateItemMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteOrdersUpdateItem(arg, options);
    };
};
export const getLiteOrdersUpdateItemMutationKey = () => [`/api/lite/orders/items`];
/**
 * @summary 更新用戶商品數量
 */
export const useLiteOrdersUpdateItem = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteOrdersUpdateItemMutationKey();
    const swrFn = getLiteOrdersUpdateItemMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteOrdersGetItemsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/lite/orders/items?${stringifiedParams}`)
        : createFullURL(`/api/lite/orders/items`);
};
export const liteOrdersGetItems = async (params, options) => {
    const res = await fetch(getLiteOrdersGetItemsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteOrdersGetItemsKey = (params) => [`/api/lite/orders/items`, ...(params ? [params] : [])];
/**
 * @summary 取得用戶的商品選擇
 */
export const useLiteOrdersGetItems = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteOrdersGetItemsKey(params) : null));
    const swrFn = () => liteOrdersGetItems(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSubscriptionStatusUrl = () => {
    return createFullURL(`/api/lite/subscription/status`);
};
export const liteSubscriptionStatus = async (options) => {
    const res = await fetch(getLiteSubscriptionStatusUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSubscriptionStatusKey = () => [`/api/lite/subscription/status`];
/**
 * @summary 訂閱狀態
 */
export const useLiteSubscriptionStatus = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteSubscriptionStatusKey() : null));
    const swrFn = () => liteSubscriptionStatus(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSubscriptionPayUrl = () => {
    return createFullURL(`/api/lite/subscription/pay`);
};
export const liteSubscriptionPay = async (liteSubscriptionPayBody, options) => {
    const res = await fetch(getLiteSubscriptionPayUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteSubscriptionPayBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSubscriptionPayMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteSubscriptionPay(arg, options);
    };
};
export const getLiteSubscriptionPayMutationKey = () => [`/api/lite/subscription/pay`];
/**
 * @summary 訂閱付款（Pay by Prime）
 */
export const useLiteSubscriptionPay = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteSubscriptionPayMutationKey();
    const swrFn = getLiteSubscriptionPayMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSubscriptionCancelUrl = () => {
    return createFullURL(`/api/lite/subscription/cancel`);
};
export const liteSubscriptionCancel = async (options) => {
    const res = await fetch(getLiteSubscriptionCancelUrl(), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSubscriptionCancelMutationFetcher = (options) => {
    return (_, __) => {
        return liteSubscriptionCancel(options);
    };
};
export const getLiteSubscriptionCancelMutationKey = () => [`/api/lite/subscription/cancel`];
/**
 * @summary 取消訂閱（本期結束後不續訂）
 */
export const useLiteSubscriptionCancel = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteSubscriptionCancelMutationKey();
    const swrFn = getLiteSubscriptionCancelMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSubscriptionPayEcPayUrl = () => {
    return createFullURL(`/api/lite/subscription/pay-ecpay`);
};
export const liteSubscriptionPayEcPay = async (liteSubscriptionPayEcPayBody, options) => {
    const res = await fetch(getLiteSubscriptionPayEcPayUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteSubscriptionPayEcPayBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSubscriptionPayEcPayMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteSubscriptionPayEcPay(arg, options);
    };
};
export const getLiteSubscriptionPayEcPayMutationKey = () => [`/api/lite/subscription/pay-ecpay`];
/**
 * @summary 訂閱付款（綠界金流）
 */
export const useLiteSubscriptionPayEcPay = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteSubscriptionPayEcPayMutationKey();
    const swrFn = getLiteSubscriptionPayEcPayMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteAnnouncementsGetActiveUrl = () => {
    return createFullURL(`/api/lite/announcements/active`);
};
export const liteAnnouncementsGetActive = async (options) => {
    const res = await fetch(getLiteAnnouncementsGetActiveUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteAnnouncementsGetActiveKey = () => [`/api/lite/announcements/active`];
/**
 * @summary 取得當前有效公告
 */
export const useLiteAnnouncementsGetActive = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteAnnouncementsGetActiveKey() : null));
    const swrFn = () => liteAnnouncementsGetActive(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSquaresListMyUrl = () => {
    return createFullURL(`/api/lite/squares`);
};
export const liteSquaresListMy = async (options) => {
    const res = await fetch(getLiteSquaresListMyUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSquaresListMyKey = () => [`/api/lite/squares`];
/**
 * @summary 列出我的 Square
 */
export const useLiteSquaresListMy = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteSquaresListMyKey() : null));
    const swrFn = () => liteSquaresListMy(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSquaresCreateUrl = () => {
    return createFullURL(`/api/lite/squares`);
};
export const liteSquaresCreate = async (liteSquaresCreateBody, options) => {
    const res = await fetch(getLiteSquaresCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(liteSquaresCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSquaresCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return liteSquaresCreate(arg, options);
    };
};
export const getLiteSquaresCreateMutationKey = () => [`/api/lite/squares`];
/**
 * @summary 建立 Square
 */
export const useLiteSquaresCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getLiteSquaresCreateMutationKey();
    const swrFn = getLiteSquaresCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteSquaresGetBySuffixUrl = (suffix) => {
    return createFullURL(`/api/lite/squares/by-suffix/${suffix}`);
};
export const liteSquaresGetBySuffix = async (suffix, options) => {
    const res = await fetch(getLiteSquaresGetBySuffixUrl(suffix), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteSquaresGetBySuffixKey = (suffix) => [`/api/lite/squares/by-suffix/${suffix}`];
/**
 * @summary 依後綴查詢 Square
 */
export const useLiteSquaresGetBySuffix = (suffix, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!suffix;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteSquaresGetBySuffixKey(suffix) : null));
    const swrFn = () => liteSquaresGetBySuffix(suffix, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getLiteShortResolveUrl = (shortCode) => {
    return createFullURL(`/api/lite/short/${shortCode}`);
};
export const liteShortResolve = async (shortCode, options) => {
    const res = await fetch(getLiteShortResolveUrl(shortCode), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getLiteShortResolveKey = (shortCode) => [`/api/lite/short/${shortCode}`];
/**
 * @summary 解析短碼取得轉址 URL
 */
export const useLiteShortResolve = (shortCode, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!shortCode;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getLiteShortResolveKey(shortCode) : null));
    const swrFn = () => liteShortResolve(shortCode, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiSuperAdminAuthGoogleUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/auth/google?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/auth/google`);
};
export const getApiSuperAdminAuthGoogle = async (params, options) => {
    const res = await fetch(getGetApiSuperAdminAuthGoogleUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiSuperAdminAuthGoogleKey = (params) => [`/api/super-admin/auth/google`, ...(params ? [params] : [])];
/**
 * @summary Super Admin Google OAuth 登入
 */
export const useGetApiSuperAdminAuthGoogle = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiSuperAdminAuthGoogleKey(params) : null));
    const swrFn = () => getApiSuperAdminAuthGoogle(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiSuperAdminAuthGoogleCallbackUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/auth/google/callback?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/auth/google/callback`);
};
export const getApiSuperAdminAuthGoogleCallback = async (params, options) => {
    const res = await fetch(getGetApiSuperAdminAuthGoogleCallbackUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiSuperAdminAuthGoogleCallbackKey = (params) => [
    `/api/super-admin/auth/google/callback`,
    ...(params ? [params] : []),
];
/**
 * @summary Super Admin Google OAuth 回調
 */
export const useGetApiSuperAdminAuthGoogleCallback = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => isEnabled ? getGetApiSuperAdminAuthGoogleCallbackKey(params) : null);
    const swrFn = () => getApiSuperAdminAuthGoogleCallback(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiSuperAdminAuthVerifyTotpUrl = () => {
    return createFullURL(`/api/super-admin/auth/verify-totp`);
};
export const postApiSuperAdminAuthVerifyTotp = async (postApiSuperAdminAuthVerifyTotpBody, options) => {
    const res = await fetch(getPostApiSuperAdminAuthVerifyTotpUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiSuperAdminAuthVerifyTotpBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiSuperAdminAuthVerifyTotpMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiSuperAdminAuthVerifyTotp(arg, options);
    };
};
export const getPostApiSuperAdminAuthVerifyTotpMutationKey = () => [`/api/super-admin/auth/verify-totp`];
/**
 * @summary 驗證 TOTP
 */
export const usePostApiSuperAdminAuthVerifyTotp = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiSuperAdminAuthVerifyTotpMutationKey();
    const swrFn = getPostApiSuperAdminAuthVerifyTotpMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetAuditLogsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/audit-logs?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/audit-logs`);
};
export const superAdminGetAuditLogs = async (params, options) => {
    const res = await fetch(getSuperAdminGetAuditLogsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetAuditLogsKey = (params) => [`/api/super-admin/audit-logs`, ...(params ? [params] : [])];
/**
 * @summary 取得稽核日誌列表
 */
export const useSuperAdminGetAuditLogs = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetAuditLogsKey(params) : null));
    const swrFn = () => superAdminGetAuditLogs(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetAuditLogsStatsUrl = () => {
    return createFullURL(`/api/super-admin/audit-logs/stats`);
};
export const superAdminGetAuditLogsStats = async (options) => {
    const res = await fetch(getSuperAdminGetAuditLogsStatsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetAuditLogsStatsKey = () => [`/api/super-admin/audit-logs/stats`];
/**
 * @summary 取得稽核日誌統計資訊
 */
export const useSuperAdminGetAuditLogsStats = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetAuditLogsStatsKey() : null));
    const swrFn = () => superAdminGetAuditLogsStats(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetAuditLogByIdUrl = (id) => {
    return createFullURL(`/api/super-admin/audit-logs/${id}`);
};
export const superAdminGetAuditLogById = async (id, options) => {
    const res = await fetch(getSuperAdminGetAuditLogByIdUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetAuditLogByIdKey = (id) => [`/api/super-admin/audit-logs/${id}`];
/**
 * @summary 取得稽核日誌詳情
 */
export const useSuperAdminGetAuditLogById = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetAuditLogByIdKey(id) : null));
    const swrFn = () => superAdminGetAuditLogById(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetFeatureFlagsUrl = () => {
    return createFullURL(`/api/super-admin/feature-flags`);
};
export const superAdminGetFeatureFlags = async (options) => {
    const res = await fetch(getSuperAdminGetFeatureFlagsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetFeatureFlagsKey = () => [`/api/super-admin/feature-flags`];
/**
 * @summary 取得 Feature Flags 列表
 */
export const useSuperAdminGetFeatureFlags = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetFeatureFlagsKey() : null));
    const swrFn = () => superAdminGetFeatureFlags(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminCreateFeatureFlagUrl = () => {
    return createFullURL(`/api/super-admin/feature-flags`);
};
export const superAdminCreateFeatureFlag = async (superAdminCreateFeatureFlagBody, options) => {
    const res = await fetch(getSuperAdminCreateFeatureFlagUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminCreateFeatureFlagBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminCreateFeatureFlagMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminCreateFeatureFlag(arg, options);
    };
};
export const getSuperAdminCreateFeatureFlagMutationKey = () => [`/api/super-admin/feature-flags`];
/**
 * @summary 建立 Feature Flag
 */
export const useSuperAdminCreateFeatureFlag = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminCreateFeatureFlagMutationKey();
    const swrFn = getSuperAdminCreateFeatureFlagMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateFeatureFlagUrl = (key) => {
    return createFullURL(`/api/super-admin/feature-flags/${key}`);
};
export const superAdminUpdateFeatureFlag = async (key, superAdminUpdateFeatureFlagBody, options) => {
    const res = await fetch(getSuperAdminUpdateFeatureFlagUrl(key), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateFeatureFlagBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateFeatureFlagMutationFetcher = (key, options) => {
    return (_, { arg }) => {
        return superAdminUpdateFeatureFlag(key, arg, options);
    };
};
export const getSuperAdminUpdateFeatureFlagMutationKey = (key) => [`/api/super-admin/feature-flags/${key}`];
/**
 * @summary 更新 Feature Flag
 */
export const useSuperAdminUpdateFeatureFlag = (key, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateFeatureFlagMutationKey(key);
    const swrFn = getSuperAdminUpdateFeatureFlagMutationFetcher(key, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeleteFeatureFlagUrl = (key) => {
    return createFullURL(`/api/super-admin/feature-flags/${key}`);
};
export const superAdminDeleteFeatureFlag = async (key, options) => {
    const res = await fetch(getSuperAdminDeleteFeatureFlagUrl(key), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeleteFeatureFlagMutationFetcher = (key, options) => {
    return (_, __) => {
        return superAdminDeleteFeatureFlag(key, options);
    };
};
export const getSuperAdminDeleteFeatureFlagMutationKey = (key) => [`/api/super-admin/feature-flags/${key}`];
/**
 * @summary 刪除 Feature Flag
 */
export const useSuperAdminDeleteFeatureFlag = (key, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeleteFeatureFlagMutationKey(key);
    const swrFn = getSuperAdminDeleteFeatureFlagMutationFetcher(key, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetFeatureFlagTenantsUrl = (key) => {
    return createFullURL(`/api/super-admin/feature-flags/${key}/tenants`);
};
export const superAdminGetFeatureFlagTenants = async (key, options) => {
    const res = await fetch(getSuperAdminGetFeatureFlagTenantsUrl(key), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetFeatureFlagTenantsKey = (key) => [`/api/super-admin/feature-flags/${key}/tenants`];
/**
 * @summary 查看啟用該功能的租戶列表
 */
export const useSuperAdminGetFeatureFlagTenants = (key, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!key;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetFeatureFlagTenantsKey(key) : null));
    const swrFn = () => superAdminGetFeatureFlagTenants(key, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetTenantsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/tenants?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/tenants`);
};
export const superAdminGetTenants = async (params, options) => {
    const res = await fetch(getSuperAdminGetTenantsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetTenantsKey = (params) => [`/api/super-admin/tenants`, ...(params ? [params] : [])];
/**
 * @summary 取得租戶列表
 */
export const useSuperAdminGetTenants = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetTenantsKey(params) : null));
    const swrFn = () => superAdminGetTenants(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetTenantByIdUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/${id}`);
};
export const superAdminGetTenantById = async (id, options) => {
    const res = await fetch(getSuperAdminGetTenantByIdUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetTenantByIdKey = (id) => [`/api/super-admin/tenants/${id}`];
/**
 * @summary 取得租戶詳情
 */
export const useSuperAdminGetTenantById = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetTenantByIdKey(id) : null));
    const swrFn = () => superAdminGetTenantById(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateTenantUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/${id}`);
};
export const superAdminUpdateTenant = async (id, superAdminUpdateTenantBody, options) => {
    const res = await fetch(getSuperAdminUpdateTenantUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateTenantBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateTenantMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdateTenant(id, arg, options);
    };
};
export const getSuperAdminUpdateTenantMutationKey = (id) => [`/api/super-admin/tenants/${id}`];
/**
 * @summary 更新租戶
 */
export const useSuperAdminUpdateTenant = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateTenantMutationKey(id);
    const swrFn = getSuperAdminUpdateTenantMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeleteTenantUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/${id}`);
};
export const superAdminDeleteTenant = async (id, options) => {
    const res = await fetch(getSuperAdminDeleteTenantUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeleteTenantMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeleteTenant(id, options);
    };
};
export const getSuperAdminDeleteTenantMutationKey = (id) => [`/api/super-admin/tenants/${id}`];
/**
 * @summary 軟刪除租戶
 */
export const useSuperAdminDeleteTenant = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeleteTenantMutationKey(id);
    const swrFn = getSuperAdminDeleteTenantMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminActivateTenantUrl = (id) => {
    return createFullURL(`/api/super-admin/api/super-admin/tenants/${id}/activate`);
};
export const superAdminActivateTenant = async (id, options) => {
    const res = await fetch(getSuperAdminActivateTenantUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminActivateTenantMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminActivateTenant(id, options);
    };
};
export const getSuperAdminActivateTenantMutationKey = (id) => [`/api/super-admin/api/super-admin/tenants/${id}/activate`];
/**
 * @summary 啟用租戶
 */
export const useSuperAdminActivateTenant = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminActivateTenantMutationKey(id);
    const swrFn = getSuperAdminActivateTenantMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeactivateTenantUrl = (id) => {
    return createFullURL(`/api/super-admin/api/super-admin/tenants/${id}/deactivate`);
};
export const superAdminDeactivateTenant = async (id, options) => {
    const res = await fetch(getSuperAdminDeactivateTenantUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeactivateTenantMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeactivateTenant(id, options);
    };
};
export const getSuperAdminDeactivateTenantMutationKey = (id) => [`/api/super-admin/api/super-admin/tenants/${id}/deactivate`];
/**
 * @summary 停用租戶
 */
export const useSuperAdminDeactivateTenant = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeactivateTenantMutationKey(id);
    const swrFn = getSuperAdminDeactivateTenantMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminImpersonateTenantUrl = (id) => {
    return createFullURL(`/api/super-admin/api/super-admin/tenants/${id}/impersonate`);
};
export const superAdminImpersonateTenant = async (id, options) => {
    const res = await fetch(getSuperAdminImpersonateTenantUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminImpersonateTenantMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminImpersonateTenant(id, options);
    };
};
export const getSuperAdminImpersonateTenantMutationKey = (id) => [`/api/super-admin/api/super-admin/tenants/${id}/impersonate`];
/**
 * @summary 代理登入租戶
 */
export const useSuperAdminImpersonateTenant = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminImpersonateTenantMutationKey(id);
    const swrFn = getSuperAdminImpersonateTenantMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetTenantAnnouncementsUrl = () => {
    return createFullURL(`/api/super-admin/tenants/announcements`);
};
export const superAdminGetTenantAnnouncements = async (options) => {
    const res = await fetch(getSuperAdminGetTenantAnnouncementsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetTenantAnnouncementsKey = () => [`/api/super-admin/tenants/announcements`];
/**
 * @summary 取得租戶公告列表
 */
export const useSuperAdminGetTenantAnnouncements = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetTenantAnnouncementsKey() : null));
    const swrFn = () => superAdminGetTenantAnnouncements(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminCreateTenantAnnouncementUrl = () => {
    return createFullURL(`/api/super-admin/tenants/announcements`);
};
export const superAdminCreateTenantAnnouncement = async (superAdminCreateTenantAnnouncementBody, options) => {
    const res = await fetch(getSuperAdminCreateTenantAnnouncementUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminCreateTenantAnnouncementBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminCreateTenantAnnouncementMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminCreateTenantAnnouncement(arg, options);
    };
};
export const getSuperAdminCreateTenantAnnouncementMutationKey = () => [`/api/super-admin/tenants/announcements`];
/**
 * @summary 建立租戶公告
 */
export const useSuperAdminCreateTenantAnnouncement = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminCreateTenantAnnouncementMutationKey();
    const swrFn = getSuperAdminCreateTenantAnnouncementMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateTenantAnnouncementUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/announcements/${id}`);
};
export const superAdminUpdateTenantAnnouncement = async (id, superAdminUpdateTenantAnnouncementBody, options) => {
    const res = await fetch(getSuperAdminUpdateTenantAnnouncementUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateTenantAnnouncementBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateTenantAnnouncementMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdateTenantAnnouncement(id, arg, options);
    };
};
export const getSuperAdminUpdateTenantAnnouncementMutationKey = (id) => [`/api/super-admin/tenants/announcements/${id}`];
/**
 * @summary 更新租戶公告
 */
export const useSuperAdminUpdateTenantAnnouncement = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateTenantAnnouncementMutationKey(id);
    const swrFn = getSuperAdminUpdateTenantAnnouncementMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeleteTenantAnnouncementUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/announcements/${id}`);
};
export const superAdminDeleteTenantAnnouncement = async (id, options) => {
    const res = await fetch(getSuperAdminDeleteTenantAnnouncementUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeleteTenantAnnouncementMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeleteTenantAnnouncement(id, options);
    };
};
export const getSuperAdminDeleteTenantAnnouncementMutationKey = (id) => [`/api/super-admin/tenants/announcements/${id}`];
/**
 * @summary 刪除租戶公告
 */
export const useSuperAdminDeleteTenantAnnouncement = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeleteTenantAnnouncementMutationKey(id);
    const swrFn = getSuperAdminDeleteTenantAnnouncementMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetTenantCancellationAnalyticsUrl = () => {
    return createFullURL(`/api/super-admin/tenants/cancellation-analytics`);
};
export const superAdminGetTenantCancellationAnalytics = async (options) => {
    const res = await fetch(getSuperAdminGetTenantCancellationAnalyticsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetTenantCancellationAnalyticsKey = () => [`/api/super-admin/tenants/cancellation-analytics`];
/**
 * @summary 取得租戶退訂分析
 */
export const useSuperAdminGetTenantCancellationAnalytics = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => isEnabled ? getSuperAdminGetTenantCancellationAnalyticsKey() : null);
    const swrFn = () => superAdminGetTenantCancellationAnalytics(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetTenantQuotaUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/${id}/quota`);
};
export const superAdminGetTenantQuota = async (id, options) => {
    const res = await fetch(getSuperAdminGetTenantQuotaUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetTenantQuotaKey = (id) => [`/api/super-admin/tenants/${id}/quota`];
/**
 * @summary 取得租戶配額
 */
export const useSuperAdminGetTenantQuota = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetTenantQuotaKey(id) : null));
    const swrFn = () => superAdminGetTenantQuota(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateTenantQuotaUrl = (id) => {
    return createFullURL(`/api/super-admin/tenants/${id}/quota`);
};
export const superAdminUpdateTenantQuota = async (id, superAdminUpdateTenantQuotaBody, options) => {
    const res = await fetch(getSuperAdminUpdateTenantQuotaUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateTenantQuotaBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateTenantQuotaMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdateTenantQuota(id, arg, options);
    };
};
export const getSuperAdminUpdateTenantQuotaMutationKey = (id) => [`/api/super-admin/tenants/${id}/quota`];
/**
 * @summary 更新租戶配額覆蓋
 */
export const useSuperAdminUpdateTenantQuota = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateTenantQuotaMutationKey(id);
    const swrFn = getSuperAdminUpdateTenantQuotaMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminResetTenantQuotaUrl = (id) => {
    return createFullURL(`/api/super-admin/api/super-admin/tenants/${id}/quota/reset`);
};
export const superAdminResetTenantQuota = async (id, options) => {
    const res = await fetch(getSuperAdminResetTenantQuotaUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminResetTenantQuotaMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminResetTenantQuota(id, options);
    };
};
export const getSuperAdminResetTenantQuotaMutationKey = (id) => [`/api/super-admin/api/super-admin/tenants/${id}/quota/reset`];
/**
 * @summary 重置配額覆蓋
 */
export const useSuperAdminResetTenantQuota = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminResetTenantQuotaMutationKey(id);
    const swrFn = getSuperAdminResetTenantQuotaMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetSystemSettingsUrl = () => {
    return createFullURL(`/api/super-admin/system-settings`);
};
export const superAdminGetSystemSettings = async (options) => {
    const res = await fetch(getSuperAdminGetSystemSettingsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetSystemSettingsKey = () => [`/api/super-admin/system-settings`];
/**
 * @summary 取得系統設定列表
 */
export const useSuperAdminGetSystemSettings = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetSystemSettingsKey() : null));
    const swrFn = () => superAdminGetSystemSettings(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetSystemSettingByKeyUrl = (key) => {
    return createFullURL(`/api/super-admin/system-settings/${key}`);
};
export const superAdminGetSystemSettingByKey = async (key, options) => {
    const res = await fetch(getSuperAdminGetSystemSettingByKeyUrl(key), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetSystemSettingByKeyKey = (key) => [`/api/super-admin/system-settings/${key}`];
/**
 * @summary 取得特定系統設定
 */
export const useSuperAdminGetSystemSettingByKey = (key, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!key;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetSystemSettingByKeyKey(key) : null));
    const swrFn = () => superAdminGetSystemSettingByKey(key, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateSystemSettingUrl = (key) => {
    return createFullURL(`/api/super-admin/system-settings/${key}`);
};
export const superAdminUpdateSystemSetting = async (key, superAdminUpdateSystemSettingBody, options) => {
    const res = await fetch(getSuperAdminUpdateSystemSettingUrl(key), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateSystemSettingBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateSystemSettingMutationFetcher = (key, options) => {
    return (_, { arg }) => {
        return superAdminUpdateSystemSetting(key, arg, options);
    };
};
export const getSuperAdminUpdateSystemSettingMutationKey = (key) => [`/api/super-admin/system-settings/${key}`];
/**
 * @summary 更新系統設定
 */
export const useSuperAdminUpdateSystemSetting = (key, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateSystemSettingMutationKey(key);
    const swrFn = getSuperAdminUpdateSystemSettingMutationFetcher(key, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetPlansUrl = () => {
    return createFullURL(`/api/super-admin/plans`);
};
export const superAdminGetPlans = async (options) => {
    const res = await fetch(getSuperAdminGetPlansUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetPlansKey = () => [`/api/super-admin/plans`];
/**
 * @summary 取得方案列表
 */
export const useSuperAdminGetPlans = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetPlansKey() : null));
    const swrFn = () => superAdminGetPlans(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminCreatePlanUrl = () => {
    return createFullURL(`/api/super-admin/plans`);
};
export const superAdminCreatePlan = async (superAdminCreatePlanBody, options) => {
    const res = await fetch(getSuperAdminCreatePlanUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminCreatePlanBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminCreatePlanMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminCreatePlan(arg, options);
    };
};
export const getSuperAdminCreatePlanMutationKey = () => [`/api/super-admin/plans`];
/**
 * @summary 建立方案
 */
export const useSuperAdminCreatePlan = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminCreatePlanMutationKey();
    const swrFn = getSuperAdminCreatePlanMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetPlanByIdUrl = (id) => {
    return createFullURL(`/api/super-admin/plans/${id}`);
};
export const superAdminGetPlanById = async (id, options) => {
    const res = await fetch(getSuperAdminGetPlanByIdUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetPlanByIdKey = (id) => [`/api/super-admin/plans/${id}`];
/**
 * @summary 取得方案詳情
 */
export const useSuperAdminGetPlanById = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetPlanByIdKey(id) : null));
    const swrFn = () => superAdminGetPlanById(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdatePlanUrl = (id) => {
    return createFullURL(`/api/super-admin/plans/${id}`);
};
export const superAdminUpdatePlan = async (id, superAdminUpdatePlanBody, options) => {
    const res = await fetch(getSuperAdminUpdatePlanUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdatePlanBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdatePlanMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdatePlan(id, arg, options);
    };
};
export const getSuperAdminUpdatePlanMutationKey = (id) => [`/api/super-admin/plans/${id}`];
/**
 * @summary 更新方案
 */
export const useSuperAdminUpdatePlan = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdatePlanMutationKey(id);
    const swrFn = getSuperAdminUpdatePlanMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeletePlanUrl = (id) => {
    return createFullURL(`/api/super-admin/plans/${id}`);
};
export const superAdminDeletePlan = async (id, options) => {
    const res = await fetch(getSuperAdminDeletePlanUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeletePlanMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeletePlan(id, options);
    };
};
export const getSuperAdminDeletePlanMutationKey = (id) => [`/api/super-admin/plans/${id}`];
/**
 * @summary 刪除方案
 */
export const useSuperAdminDeletePlan = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeletePlanMutationKey(id);
    const swrFn = getSuperAdminDeletePlanMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetLiteStatsUrl = () => {
    return createFullURL(`/api/super-admin/lite/stats`);
};
export const superAdminGetLiteStats = async (options) => {
    const res = await fetch(getSuperAdminGetLiteStatsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetLiteStatsKey = () => [`/api/super-admin/lite/stats`];
/**
 * @summary 取得 LITE 統計
 */
export const useSuperAdminGetLiteStats = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetLiteStatsKey() : null));
    const swrFn = () => superAdminGetLiteStats(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetLiteGroupsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/lite/groups?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/lite/groups`);
};
export const superAdminGetLiteGroups = async (params, options) => {
    const res = await fetch(getSuperAdminGetLiteGroupsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetLiteGroupsKey = (params) => [`/api/super-admin/lite/groups`, ...(params ? [params] : [])];
/**
 * @summary 取得 LITE 群組列表
 */
export const useSuperAdminGetLiteGroups = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetLiteGroupsKey(params) : null));
    const swrFn = () => superAdminGetLiteGroups(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateLiteGroupActiveUrl = (groupId) => {
    return createFullURL(`/api/super-admin/lite/groups/${groupId}/is-active`);
};
export const superAdminUpdateLiteGroupActive = async (groupId, superAdminUpdateLiteGroupActiveBody, options) => {
    const res = await fetch(getSuperAdminUpdateLiteGroupActiveUrl(groupId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateLiteGroupActiveBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateLiteGroupActiveMutationFetcher = (groupId, options) => {
    return (_, { arg }) => {
        return superAdminUpdateLiteGroupActive(groupId, arg, options);
    };
};
export const getSuperAdminUpdateLiteGroupActiveMutationKey = (groupId) => [`/api/super-admin/lite/groups/${groupId}/is-active`];
/**
 * @summary 設定 LITE 群組啟用狀態
 */
export const useSuperAdminUpdateLiteGroupActive = (groupId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getSuperAdminUpdateLiteGroupActiveMutationKey(groupId);
    const swrFn = getSuperAdminUpdateLiteGroupActiveMutationFetcher(groupId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateLiteGroupExtraPublishQuotaUrl = (groupId) => {
    return createFullURL(`/api/super-admin/lite/groups/${groupId}/extra-publish-quota`);
};
export const superAdminUpdateLiteGroupExtraPublishQuota = async (groupId, superAdminUpdateLiteGroupExtraPublishQuotaBody, options) => {
    const res = await fetch(getSuperAdminUpdateLiteGroupExtraPublishQuotaUrl(groupId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateLiteGroupExtraPublishQuotaBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateLiteGroupExtraPublishQuotaMutationFetcher = (groupId, options) => {
    return (_, { arg }) => {
        return superAdminUpdateLiteGroupExtraPublishQuota(groupId, arg, options);
    };
};
export const getSuperAdminUpdateLiteGroupExtraPublishQuotaMutationKey = (groupId) => [`/api/super-admin/lite/groups/${groupId}/extra-publish-quota`];
/**
 * @summary 設定 LITE 群組發佈加額
 */
export const useSuperAdminUpdateLiteGroupExtraPublishQuota = (groupId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getSuperAdminUpdateLiteGroupExtraPublishQuotaMutationKey(groupId);
    const swrFn = getSuperAdminUpdateLiteGroupExtraPublishQuotaMutationFetcher(groupId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetAnnouncementsUrl = () => {
    return createFullURL(`/api/super-admin/lite/announcements`);
};
export const superAdminGetAnnouncements = async (options) => {
    const res = await fetch(getSuperAdminGetAnnouncementsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetAnnouncementsKey = () => [`/api/super-admin/lite/announcements`];
/**
 * @summary 取得公告列表
 */
export const useSuperAdminGetAnnouncements = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetAnnouncementsKey() : null));
    const swrFn = () => superAdminGetAnnouncements(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminCreateAnnouncementUrl = () => {
    return createFullURL(`/api/super-admin/lite/announcements`);
};
export const superAdminCreateAnnouncement = async (superAdminCreateAnnouncementBody, options) => {
    const res = await fetch(getSuperAdminCreateAnnouncementUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminCreateAnnouncementBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminCreateAnnouncementMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminCreateAnnouncement(arg, options);
    };
};
export const getSuperAdminCreateAnnouncementMutationKey = () => [`/api/super-admin/lite/announcements`];
/**
 * @summary 建立公告
 */
export const useSuperAdminCreateAnnouncement = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminCreateAnnouncementMutationKey();
    const swrFn = getSuperAdminCreateAnnouncementMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateAnnouncementUrl = (id) => {
    return createFullURL(`/api/super-admin/lite/announcements/${id}`);
};
export const superAdminUpdateAnnouncement = async (id, superAdminUpdateAnnouncementBody, options) => {
    const res = await fetch(getSuperAdminUpdateAnnouncementUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateAnnouncementBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateAnnouncementMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdateAnnouncement(id, arg, options);
    };
};
export const getSuperAdminUpdateAnnouncementMutationKey = (id) => [`/api/super-admin/lite/announcements/${id}`];
/**
 * @summary 更新公告
 */
export const useSuperAdminUpdateAnnouncement = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateAnnouncementMutationKey(id);
    const swrFn = getSuperAdminUpdateAnnouncementMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeleteAnnouncementUrl = (id) => {
    return createFullURL(`/api/super-admin/lite/announcements/${id}`);
};
export const superAdminDeleteAnnouncement = async (id, options) => {
    const res = await fetch(getSuperAdminDeleteAnnouncementUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeleteAnnouncementMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeleteAnnouncement(id, options);
    };
};
export const getSuperAdminDeleteAnnouncementMutationKey = (id) => [`/api/super-admin/lite/announcements/${id}`];
/**
 * @summary 刪除公告
 */
export const useSuperAdminDeleteAnnouncement = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeleteAnnouncementMutationKey(id);
    const swrFn = getSuperAdminDeleteAnnouncementMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetCancellationAnalyticsUrl = () => {
    return createFullURL(`/api/super-admin/lite/cancellation-analytics`);
};
export const superAdminGetCancellationAnalytics = async (options) => {
    const res = await fetch(getSuperAdminGetCancellationAnalyticsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetCancellationAnalyticsKey = () => [`/api/super-admin/lite/cancellation-analytics`];
/**
 * @summary 取得退訂分析
 */
export const useSuperAdminGetCancellationAnalytics = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetCancellationAnalyticsKey() : null));
    const swrFn = () => superAdminGetCancellationAnalytics(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminSendLiteAdUrl = () => {
    return createFullURL(`/api/super-admin/lite/ads/send`);
};
export const superAdminSendLiteAd = async (superAdminSendLiteAdBody, options) => {
    const res = await fetch(getSuperAdminSendLiteAdUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminSendLiteAdBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminSendLiteAdMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminSendLiteAd(arg, options);
    };
};
export const getSuperAdminSendLiteAdMutationKey = () => [`/api/super-admin/lite/ads/send`];
/**
 * @summary 發送 LITE 廣告 Flex Message
 */
export const useSuperAdminSendLiteAd = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminSendLiteAdMutationKey();
    const swrFn = getSuperAdminSendLiteAdMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminListLiteAdsPresetsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/super-admin/lite/ads/presets?${stringifiedParams}`)
        : createFullURL(`/api/super-admin/lite/ads/presets`);
};
export const superAdminListLiteAdsPresets = async (params, options) => {
    const res = await fetch(getSuperAdminListLiteAdsPresetsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminListLiteAdsPresetsKey = (params) => [`/api/super-admin/lite/ads/presets`, ...(params ? [params] : [])];
/**
 * @summary LITE 廣告版型列表
 */
export const useSuperAdminListLiteAdsPresets = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminListLiteAdsPresetsKey(params) : null));
    const swrFn = () => superAdminListLiteAdsPresets(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminCreateLiteAdsPresetUrl = () => {
    return createFullURL(`/api/super-admin/lite/ads/presets`);
};
export const superAdminCreateLiteAdsPreset = async (superAdminCreateLiteAdsPresetBody, options) => {
    const res = await fetch(getSuperAdminCreateLiteAdsPresetUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminCreateLiteAdsPresetBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminCreateLiteAdsPresetMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminCreateLiteAdsPreset(arg, options);
    };
};
export const getSuperAdminCreateLiteAdsPresetMutationKey = () => [`/api/super-admin/lite/ads/presets`];
/**
 * @summary 新增 LITE 廣告版型
 */
export const useSuperAdminCreateLiteAdsPreset = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminCreateLiteAdsPresetMutationKey();
    const swrFn = getSuperAdminCreateLiteAdsPresetMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminGetLiteAdsPresetUrl = (id) => {
    return createFullURL(`/api/super-admin/lite/ads/presets/${id}`);
};
export const superAdminGetLiteAdsPreset = async (id, options) => {
    const res = await fetch(getSuperAdminGetLiteAdsPresetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminGetLiteAdsPresetKey = (id) => [`/api/super-admin/lite/ads/presets/${id}`];
/**
 * @summary 取得 LITE 廣告版型
 */
export const useSuperAdminGetLiteAdsPreset = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuperAdminGetLiteAdsPresetKey(id) : null));
    const swrFn = () => superAdminGetLiteAdsPreset(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpdateLiteAdsPresetUrl = (id) => {
    return createFullURL(`/api/super-admin/lite/ads/presets/${id}`);
};
export const superAdminUpdateLiteAdsPreset = async (id, superAdminUpdateLiteAdsPresetBody, options) => {
    const res = await fetch(getSuperAdminUpdateLiteAdsPresetUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpdateLiteAdsPresetBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpdateLiteAdsPresetMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return superAdminUpdateLiteAdsPreset(id, arg, options);
    };
};
export const getSuperAdminUpdateLiteAdsPresetMutationKey = (id) => [`/api/super-admin/lite/ads/presets/${id}`];
/**
 * @summary 更新 LITE 廣告版型
 */
export const useSuperAdminUpdateLiteAdsPreset = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpdateLiteAdsPresetMutationKey(id);
    const swrFn = getSuperAdminUpdateLiteAdsPresetMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminDeleteLiteAdsPresetUrl = (id) => {
    return createFullURL(`/api/super-admin/lite/ads/presets/${id}`);
};
export const superAdminDeleteLiteAdsPreset = async (id, options) => {
    const res = await fetch(getSuperAdminDeleteLiteAdsPresetUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminDeleteLiteAdsPresetMutationFetcher = (id, options) => {
    return (_, __) => {
        return superAdminDeleteLiteAdsPreset(id, options);
    };
};
export const getSuperAdminDeleteLiteAdsPresetMutationKey = (id) => [`/api/super-admin/lite/ads/presets/${id}`];
/**
 * @summary 刪除 LITE 廣告版型
 */
export const useSuperAdminDeleteLiteAdsPreset = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminDeleteLiteAdsPresetMutationKey(id);
    const swrFn = getSuperAdminDeleteLiteAdsPresetMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuperAdminUpsertLiteAdsPresetUrl = () => {
    return createFullURL(`/api/super-admin/lite/ads/presets/upsert`);
};
export const superAdminUpsertLiteAdsPreset = async (superAdminUpsertLiteAdsPresetBody, options) => {
    const res = await fetch(getSuperAdminUpsertLiteAdsPresetUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(superAdminUpsertLiteAdsPresetBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuperAdminUpsertLiteAdsPresetMutationFetcher = (options) => {
    return (_, { arg }) => {
        return superAdminUpsertLiteAdsPreset(arg, options);
    };
};
export const getSuperAdminUpsertLiteAdsPresetMutationKey = () => [`/api/super-admin/lite/ads/presets/upsert`];
/**
 * @summary 依情境覆蓋儲存版型
 */
export const useSuperAdminUpsertLiteAdsPreset = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuperAdminUpsertLiteAdsPresetMutationKey();
    const swrFn = getSuperAdminUpsertLiteAdsPresetMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiCustomersUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/customers?${stringifiedParams}`)
        : createFullURL(`/api/customers`);
};
export const getApiCustomers = async (params, options) => {
    const res = await fetch(getGetApiCustomersUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiCustomersKey = (params) => [`/api/customers`, ...(params ? [params] : [])];
/**
 * @summary 取得會員列表
 */
export const useGetApiCustomers = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiCustomersKey(params) : null));
    const swrFn = () => getApiCustomers(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiCustomersUrl = () => {
    return createFullURL(`/api/customers`);
};
export const postApiCustomers = async (postApiCustomersBody, options) => {
    const res = await fetch(getPostApiCustomersUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiCustomersBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiCustomersMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiCustomers(arg, options);
    };
};
export const getPostApiCustomersMutationKey = () => [`/api/customers`];
/**
 * @summary 建立使用者
 */
export const usePostApiCustomers = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiCustomersMutationKey();
    const swrFn = getPostApiCustomersMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiCustomersIdUrl = (id) => {
    return createFullURL(`/api/customers/${id}`);
};
export const getApiCustomersId = async (id, options) => {
    const res = await fetch(getGetApiCustomersIdUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiCustomersIdKey = (id) => [`/api/customers/${id}`];
/**
 * @summary 取得使用者詳細資訊
 */
export const useGetApiCustomersId = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiCustomersIdKey(id) : null));
    const swrFn = () => getApiCustomersId(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPutApiCustomersIdUrl = (id) => {
    return createFullURL(`/api/customers/${id}`);
};
export const putApiCustomersId = async (id, putApiCustomersIdBody, options) => {
    const res = await fetch(getPutApiCustomersIdUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(putApiCustomersIdBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPutApiCustomersIdMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return putApiCustomersId(id, arg, options);
    };
};
export const getPutApiCustomersIdMutationKey = (id) => [`/api/customers/${id}`];
/**
 * @summary 更新使用者
 */
export const usePutApiCustomersId = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPutApiCustomersIdMutationKey(id);
    const swrFn = getPutApiCustomersIdMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDeleteApiCustomersIdUrl = (id) => {
    return createFullURL(`/api/customers/${id}`);
};
export const deleteApiCustomersId = async (id, options) => {
    const res = await fetch(getDeleteApiCustomersIdUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDeleteApiCustomersIdMutationFetcher = (id, options) => {
    return (_, __) => {
        return deleteApiCustomersId(id, options);
    };
};
export const getDeleteApiCustomersIdMutationKey = (id) => [`/api/customers/${id}`];
/**
 * @summary 刪除使用者
 */
export const useDeleteApiCustomersId = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDeleteApiCustomersIdMutationKey(id);
    const swrFn = getDeleteApiCustomersIdMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiCustomersIdCouponsOwnedUrl = (id) => {
    return createFullURL(`/api/customers/${id}/coupons/owned`);
};
export const getApiCustomersIdCouponsOwned = async (id, options) => {
    const res = await fetch(getGetApiCustomersIdCouponsOwnedUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiCustomersIdCouponsOwnedKey = (id) => [`/api/customers/${id}/coupons/owned`];
/**
 * @summary 取得使用者擁有的優惠券
 */
export const useGetApiCustomersIdCouponsOwned = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiCustomersIdCouponsOwnedKey(id) : null));
    const swrFn = () => getApiCustomersIdCouponsOwned(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersGetCheckoutPreferencesUrl = (lineId) => {
    return createFullURL(`/api/customers/by-line-id/${lineId}/checkout-preferences`);
};
export const customersGetCheckoutPreferences = async (lineId, options) => {
    const res = await fetch(getCustomersGetCheckoutPreferencesUrl(lineId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersGetCheckoutPreferencesKey = (lineId) => [`/api/customers/by-line-id/${lineId}/checkout-preferences`];
/**
 * @summary 取得結帳偏好
 */
export const useCustomersGetCheckoutPreferences = (lineId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!lineId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getCustomersGetCheckoutPreferencesKey(lineId) : null));
    const swrFn = () => customersGetCheckoutPreferences(lineId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersGetByLineIdUrl = (lineId) => {
    return createFullURL(`/api/customers/by-line-id/${lineId}`);
};
export const usersGetByLineId = async (lineId, options) => {
    const res = await fetch(getUsersGetByLineIdUrl(lineId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersGetByLineIdKey = (lineId) => [`/api/customers/by-line-id/${lineId}`];
/**
 * @summary 根據 LINE ID 查詢使用者
 */
export const useUsersGetByLineId = (lineId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!lineId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getUsersGetByLineIdKey(lineId) : null));
    const swrFn = () => usersGetByLineId(lineId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersGetOrCreateByLineIdUrl = () => {
    return createFullURL(`/api/customers/get-or-create-by-line-id`);
};
export const customersGetOrCreateByLineId = async (customersGetOrCreateByLineIdBody, options) => {
    const res = await fetch(getCustomersGetOrCreateByLineIdUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customersGetOrCreateByLineIdBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersGetOrCreateByLineIdMutationFetcher = (options) => {
    return (_, { arg }) => {
        return customersGetOrCreateByLineId(arg, options);
    };
};
export const getCustomersGetOrCreateByLineIdMutationKey = () => [`/api/customers/get-or-create-by-line-id`];
/**
 * @summary 登入即加會員
 */
export const useCustomersGetOrCreateByLineId = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCustomersGetOrCreateByLineIdMutationKey();
    const swrFn = getCustomersGetOrCreateByLineIdMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersGetPointsHistoryUrl = (id, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/customers/${id}/points-history?${stringifiedParams}`)
        : createFullURL(`/api/customers/${id}/points-history`);
};
export const usersGetPointsHistory = async (id, params, options) => {
    const res = await fetch(getUsersGetPointsHistoryUrl(id, params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersGetPointsHistoryKey = (id, params) => [`/api/customers/${id}/points-history`, ...(params ? [params] : [])];
/**
 * @summary 取得使用者點數交易歷史
 */
export const useUsersGetPointsHistory = (id, params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getUsersGetPointsHistoryKey(id, params) : null));
    const swrFn = () => usersGetPointsHistory(id, params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersPhoneSendOtpUrl = () => {
    return createFullURL(`/api/customers/phone/send-otp`);
};
export const customersPhoneSendOtp = async (customersPhoneSendOtpBody, options) => {
    const res = await fetch(getCustomersPhoneSendOtpUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customersPhoneSendOtpBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersPhoneSendOtpMutationFetcher = (options) => {
    return (_, { arg }) => {
        return customersPhoneSendOtp(arg, options);
    };
};
export const getCustomersPhoneSendOtpMutationKey = () => [`/api/customers/phone/send-otp`];
/**
 * @summary 發送手機驗證 OTP
 */
export const useCustomersPhoneSendOtp = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCustomersPhoneSendOtpMutationKey();
    const swrFn = getCustomersPhoneSendOtpMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersPhoneVerifyUrl = () => {
    return createFullURL(`/api/customers/phone/verify`);
};
export const customersPhoneVerify = async (customersPhoneVerifyBody, options) => {
    const res = await fetch(getCustomersPhoneVerifyUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customersPhoneVerifyBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersPhoneVerifyMutationFetcher = (options) => {
    return (_, { arg }) => {
        return customersPhoneVerify(arg, options);
    };
};
export const getCustomersPhoneVerifyMutationKey = () => [`/api/customers/phone/verify`];
/**
 * @summary 驗證 OTP 並完成手機驗證
 */
export const useCustomersPhoneVerify = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCustomersPhoneVerifyMutationKey();
    const swrFn = getCustomersPhoneVerifyMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersPushMessageUrl = () => {
    return createFullURL(`/api/customers/push-message`);
};
export const usersPushMessage = async (usersPushMessageBody, options) => {
    const res = await fetch(getUsersPushMessageUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(usersPushMessageBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersPushMessageMutationFetcher = (options) => {
    return (_, { arg }) => {
        return usersPushMessage(arg, options);
    };
};
export const getUsersPushMessageMutationKey = () => [`/api/customers/push-message`];
/**
 * @summary 批量推播訊息給用戶
 */
export const useUsersPushMessage = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getUsersPushMessageMutationKey();
    const swrFn = getUsersPushMessageMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getVouchersRedeemUrl = () => {
    return createFullURL(`/api/vouchers/redeem`);
};
export const vouchersRedeem = async (vouchersRedeemBody, options) => {
    const res = await fetch(getVouchersRedeemUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(vouchersRedeemBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getVouchersRedeemMutationFetcher = (options) => {
    return (_, { arg }) => {
        return vouchersRedeem(arg, options);
    };
};
export const getVouchersRedeemMutationKey = () => [`/api/vouchers/redeem`];
/**
 * @summary 核銷電子券
 */
export const useVouchersRedeem = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getVouchersRedeemMutationKey();
    const swrFn = getVouchersRedeemMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersGetVouchersUrl = (id, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/customers/${id}/vouchers?${stringifiedParams}`)
        : createFullURL(`/api/customers/${id}/vouchers`);
};
export const customersGetVouchers = async (id, params, options) => {
    const res = await fetch(getCustomersGetVouchersUrl(id, params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersGetVouchersKey = (id, params) => [`/api/customers/${id}/vouchers`, ...(params ? [params] : [])];
/**
 * @summary 取得會員電子券列表
 */
export const useCustomersGetVouchers = (id, params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getCustomersGetVouchersKey(id, params) : null));
    const swrFn = () => customersGetVouchers(id, params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCustomersGetPackagesUrl = (id, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/customers/${id}/packages?${stringifiedParams}`)
        : createFullURL(`/api/customers/${id}/packages`);
};
export const customersGetPackages = async (id, params, options) => {
    const res = await fetch(getCustomersGetPackagesUrl(id, params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCustomersGetPackagesKey = (id, params) => [`/api/customers/${id}/packages`, ...(params ? [params] : [])];
/**
 * @summary 取得會員票券列表
 */
export const useCustomersGetPackages = (id, params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getCustomersGetPackagesKey(id, params) : null));
    const swrFn = () => customersGetPackages(id, params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersGetByPhoneUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/user-by-phone?${stringifiedParams}`)
        : createFullURL(`/api/user-by-phone`);
};
export const usersGetByPhone = async (params, options) => {
    const res = await fetch(getUsersGetByPhoneUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersGetByPhoneKey = (params) => [`/api/user-by-phone`, ...(params ? [params] : [])];
/**
 * @summary 根據手機號碼查詢使用者
 */
export const useUsersGetByPhone = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getUsersGetByPhoneKey(params) : null));
    const swrFn = () => usersGetByPhone(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersGetAvailableCouponsUrl = (id, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/users/${id}/available-coupons?${stringifiedParams}`)
        : createFullURL(`/api/users/${id}/available-coupons`);
};
export const usersGetAvailableCoupons = async (id, params, options) => {
    const res = await fetch(getUsersGetAvailableCouponsUrl(id, params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersGetAvailableCouponsKey = (id, params) => [`/api/users/${id}/available-coupons`, ...(params ? [params] : [])];
/**
 * @summary 取得使用者可用優惠券
 */
export const useUsersGetAvailableCoupons = (id, params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getUsersGetAvailableCouponsKey(id, params) : null));
    const swrFn = () => usersGetAvailableCoupons(id, params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/staff?${stringifiedParams}`)
        : createFullURL(`/api/staff`);
};
export const staffList = async (params, options) => {
    const res = await fetch(getStaffListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffListKey = (params) => [`/api/staff`, ...(params ? [params] : [])];
/**
 * @summary 取得工作人員列表
 */
export const useStaffList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getStaffListKey(params) : null));
    const swrFn = () => staffList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffCreateUrl = () => {
    return createFullURL(`/api/staff`);
};
export const staffCreate = async (staffCreateBody, options) => {
    const res = await fetch(getStaffCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(staffCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return staffCreate(arg, options);
    };
};
export const getStaffCreateMutationKey = () => [`/api/staff`];
/**
 * @summary 建立工作人員
 */
export const useStaffCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getStaffCreateMutationKey();
    const swrFn = getStaffCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffGetMeUrl = () => {
    return createFullURL(`/api/staff/me`);
};
export const staffGetMe = async (options) => {
    const res = await fetch(getStaffGetMeUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffGetMeKey = () => [`/api/staff/me`];
/**
 * @summary 取得當前使用者的工作人員資訊
 */
export const useStaffGetMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getStaffGetMeKey() : null));
    const swrFn = () => staffGetMe(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffCreateMeUrl = () => {
    return createFullURL(`/api/staff/me`);
};
export const staffCreateMe = async (staffCreateMeBody, options) => {
    const res = await fetch(getStaffCreateMeUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(staffCreateMeBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffCreateMeMutationFetcher = (options) => {
    return (_, { arg }) => {
        return staffCreateMe(arg, options);
    };
};
export const getStaffCreateMeMutationKey = () => [`/api/staff/me`];
/**
 * @summary 為當前使用者創建工作人員
 */
export const useStaffCreateMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getStaffCreateMeMutationKey();
    const swrFn = getStaffCreateMeMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffGetUrl = (id) => {
    return createFullURL(`/api/staff/${id}`);
};
export const staffGet = async (id, options) => {
    const res = await fetch(getStaffGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return { data, status: res.status, headers: res.headers };
};
export const getStaffGetKey = (id) => [`/api/staff/${id}`];
/**
 * @summary 取得工作人員詳細資訊
 */
export const useStaffGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getStaffGetKey(id) : null));
    const swrFn = () => staffGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffUpdateUrl = (id) => {
    return createFullURL(`/api/staff/${id}`);
};
export const staffUpdate = async (id, staffUpdateBody, options) => {
    const res = await fetch(getStaffUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(staffUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return staffUpdate(id, arg, options);
    };
};
export const getStaffUpdateMutationKey = (id) => [`/api/staff/${id}`];
/**
 * @summary 更新工作人員
 */
export const useStaffUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getStaffUpdateMutationKey(id);
    const swrFn = getStaffUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getStaffDeleteUrl = (id) => {
    return createFullURL(`/api/staff/${id}`);
};
export const staffDelete = async (id, options) => {
    const res = await fetch(getStaffDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getStaffDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return staffDelete(id, options);
    };
};
export const getStaffDeleteMutationKey = (id) => [`/api/staff/${id}`];
/**
 * @summary 刪除工作人員
 */
export const useStaffDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getStaffDeleteMutationKey(id);
    const swrFn = getStaffDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesRegisterUrl = () => {
    return createFullURL(`/api/devices/register`);
};
export const devicesRegister = async (devicesRegisterBody, options) => {
    const res = await fetch(getDevicesRegisterUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(devicesRegisterBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesRegisterMutationFetcher = (options) => {
    return (_, { arg }) => {
        return devicesRegister(arg, options);
    };
};
export const getDevicesRegisterMutationKey = () => [`/api/devices/register`];
/**
 * @summary 註冊裝置
 */
export const useDevicesRegister = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDevicesRegisterMutationKey();
    const swrFn = getDevicesRegisterMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/devices?${stringifiedParams}`)
        : createFullURL(`/api/devices`);
};
export const devicesList = async (params, options) => {
    const res = await fetch(getDevicesListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesListKey = (params) => [`/api/devices`, ...(params ? [params] : [])];
/**
 * @summary 取得裝置列表
 */
export const useDevicesList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getDevicesListKey(params) : null));
    const swrFn = () => devicesList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesGetUrl = (id) => {
    return createFullURL(`/api/devices/${id}`);
};
export const devicesGet = async (id, options) => {
    const res = await fetch(getDevicesGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesGetKey = (id) => [`/api/devices/${id}`];
/**
 * @summary 取得裝置詳細資訊
 */
export const useDevicesGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesGetKey(id) : null));
    const swrFn = () => devicesGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesUpdateUrl = (id) => {
    return createFullURL(`/api/devices/${id}`);
};
export const devicesUpdate = async (id, devicesUpdateBody, options) => {
    const res = await fetch(getDevicesUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(devicesUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return devicesUpdate(id, arg, options);
    };
};
export const getDevicesUpdateMutationKey = (id) => [`/api/devices/${id}`];
/**
 * @summary 更新裝置
 */
export const useDevicesUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDevicesUpdateMutationKey(id);
    const swrFn = getDevicesUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesDeleteUrl = (id) => {
    return createFullURL(`/api/devices/${id}`);
};
export const devicesDelete = async (id, options) => {
    const res = await fetch(getDevicesDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return devicesDelete(id, options);
    };
};
export const getDevicesDeleteMutationKey = (id) => [`/api/devices/${id}`];
/**
 * @summary 撤銷裝置授權
 */
export const useDevicesDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDevicesDeleteMutationKey(id);
    const swrFn = getDevicesDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDevicesDeleteCurrentUrl = () => {
    return createFullURL(`/api/devices/current`);
};
export const devicesDeleteCurrent = async (devicesDeleteCurrentBody, options) => {
    const res = await fetch(getDevicesDeleteCurrentUrl(), {
        ...options,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(devicesDeleteCurrentBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDevicesDeleteCurrentMutationFetcher = (options) => {
    return (_, { arg }) => {
        return devicesDeleteCurrent(arg, options);
    };
};
export const getDevicesDeleteCurrentMutationKey = () => [`/api/devices/current`];
/**
 * @summary 刪除當前裝置
 */
export const useDevicesDeleteCurrent = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDevicesDeleteCurrentMutationKey();
    const swrFn = getDevicesDeleteCurrentMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAccountsGetByUserIdUrl = (userId) => {
    return createFullURL(`/api/accounts/user/${userId}`);
};
export const accountsGetByUserId = async (userId, options) => {
    const res = await fetch(getAccountsGetByUserIdUrl(userId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAccountsGetByUserIdKey = (userId) => [`/api/accounts/user/${userId}`];
/**
 * @summary 取得全域使用者的所有帳號
 */
export const useAccountsGetByUserId = (userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!userId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAccountsGetByUserIdKey(userId) : null));
    const swrFn = () => accountsGetByUserId(userId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAccountsGetUrl = (id) => {
    return createFullURL(`/api/accounts/${id}`);
};
export const accountsGet = async (id, options) => {
    const res = await fetch(getAccountsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAccountsGetKey = (id) => [`/api/accounts/${id}`];
/**
 * @summary 取得帳號詳細資訊
 */
export const useAccountsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAccountsGetKey(id) : null));
    const swrFn = () => accountsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAccountsUpdateUrl = (id) => {
    return createFullURL(`/api/accounts/${id}`);
};
export const accountsUpdate = async (id, accountsUpdateBody, options) => {
    const res = await fetch(getAccountsUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(accountsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAccountsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return accountsUpdate(id, arg, options);
    };
};
export const getAccountsUpdateMutationKey = (id) => [`/api/accounts/${id}`];
/**
 * @summary 更新帳號
 */
export const useAccountsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAccountsUpdateMutationKey(id);
    const swrFn = getAccountsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAccountsDeleteUrl = (id) => {
    return createFullURL(`/api/accounts/${id}`);
};
export const accountsDelete = async (id, options) => {
    const res = await fetch(getAccountsDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAccountsDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return accountsDelete(id, options);
    };
};
export const getAccountsDeleteMutationKey = (id) => [`/api/accounts/${id}`];
/**
 * @summary 刪除帳號
 */
export const useAccountsDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAccountsDeleteMutationKey(id);
    const swrFn = getAccountsDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAccountsCreateUrl = () => {
    return createFullURL(`/api/accounts`);
};
export const accountsCreate = async (accountsCreateBody, options) => {
    const res = await fetch(getAccountsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(accountsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAccountsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return accountsCreate(arg, options);
    };
};
export const getAccountsCreateMutationKey = () => [`/api/accounts`];
/**
 * @summary 建立帳號
 */
export const useAccountsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAccountsCreateMutationKey();
    const swrFn = getAccountsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersGetMeUrl = () => {
    return createFullURL(`/api/members/me`);
};
export const membersGetMe = async (options) => {
    const res = await fetch(getMembersGetMeUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersGetMeKey = () => [`/api/members/me`];
/**
 * @summary 取得當前使用者的權限資訊
 */
export const useMembersGetMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMembersGetMeKey() : null));
    const swrFn = () => membersGetMe(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersListUrl = () => {
    return createFullURL(`/api/members`);
};
export const membersList = async (options) => {
    const res = await fetch(getMembersListUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersListKey = () => [`/api/members`];
/**
 * @summary 取得權限列表
 */
export const useMembersList = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMembersListKey() : null));
    const swrFn = () => membersList(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersCreateUrl = () => {
    return createFullURL(`/api/members`);
};
export const membersCreate = async (membersCreateBody, options) => {
    const res = await fetch(getMembersCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(membersCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return membersCreate(arg, options);
    };
};
export const getMembersCreateMutationKey = () => [`/api/members`];
/**
 * @summary 建立權限
 */
export const useMembersCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMembersCreateMutationKey();
    const swrFn = getMembersCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersGetByUserIdUrl = (userId) => {
    return createFullURL(`/api/members/user/${userId}`);
};
export const membersGetByUserId = async (userId, options) => {
    const res = await fetch(getMembersGetByUserIdUrl(userId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersGetByUserIdKey = (userId) => [`/api/members/user/${userId}`];
/**
 * @summary 根據全域使用者 ID 取得權限
 */
export const useMembersGetByUserId = (userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!userId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getMembersGetByUserIdKey(userId) : null));
    const swrFn = () => membersGetByUserId(userId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersUpdateUrl = (userId) => {
    return createFullURL(`/api/members/user/${userId}`);
};
export const membersUpdate = async (userId, membersUpdateBody, options) => {
    const res = await fetch(getMembersUpdateUrl(userId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(membersUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersUpdateMutationFetcher = (userId, options) => {
    return (_, { arg }) => {
        return membersUpdate(userId, arg, options);
    };
};
export const getMembersUpdateMutationKey = (userId) => [`/api/members/user/${userId}`];
/**
 * @summary 更新權限
 */
export const useMembersUpdate = (userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMembersUpdateMutationKey(userId);
    const swrFn = getMembersUpdateMutationFetcher(userId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersDeleteUrl = (userId) => {
    return createFullURL(`/api/members/user/${userId}`);
};
export const membersDelete = async (userId, options) => {
    const res = await fetch(getMembersDeleteUrl(userId), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersDeleteMutationFetcher = (userId, options) => {
    return (_, __) => {
        return membersDelete(userId, options);
    };
};
export const getMembersDeleteMutationKey = (userId) => [`/api/members/user/${userId}`];
/**
 * @summary 刪除權限
 */
export const useMembersDelete = (userId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMembersDeleteMutationKey(userId);
    const swrFn = getMembersDeleteMutationFetcher(userId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMembersGetWithoutStaffUrl = () => {
    return createFullURL(`/api/members/without-staff`);
};
export const membersGetWithoutStaff = async (options) => {
    const res = await fetch(getMembersGetWithoutStaffUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMembersGetWithoutStaffKey = () => [`/api/members/without-staff`];
/**
 * @summary 取得沒有 staff 的 members
 */
export const useMembersGetWithoutStaff = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getMembersGetWithoutStaffKey() : null));
    const swrFn = () => membersGetWithoutStaff(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesCreateUrl = () => {
    return createFullURL(`/api/invites`);
};
export const invitesCreate = async (invitesCreateBody, options) => {
    const res = await fetch(getInvitesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(invitesCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return invitesCreate(arg, options);
    };
};
export const getInvitesCreateMutationKey = () => [`/api/invites`];
/**
 * @summary 建立邀請
 */
export const useInvitesCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvitesCreateMutationKey();
    const swrFn = getInvitesCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesListUrl = () => {
    return createFullURL(`/api/invites`);
};
export const invitesList = async (options) => {
    const res = await fetch(getInvitesListUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesListKey = () => [`/api/invites`];
/**
 * @summary 取得邀請列表
 */
export const useInvitesList = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getInvitesListKey() : null));
    const swrFn = () => invitesList(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesGetByCodeUrl = (inviteCode) => {
    return createFullURL(`/api/invites/by-code/${inviteCode}`);
};
export const invitesGetByCode = async (inviteCode, options) => {
    const res = await fetch(getInvitesGetByCodeUrl(inviteCode), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesGetByCodeKey = (inviteCode) => [`/api/invites/by-code/${inviteCode}`];
/**
 * @summary 根據邀請碼取得邀請詳情
 */
export const useInvitesGetByCode = (inviteCode, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!inviteCode;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInvitesGetByCodeKey(inviteCode) : null));
    const swrFn = () => invitesGetByCode(inviteCode, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesGetInfoUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/invites/info?${stringifiedParams}`)
        : createFullURL(`/api/invites/info`);
};
export const invitesGetInfo = async (params, options) => {
    const res = await fetch(getInvitesGetInfoUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesGetInfoKey = (params) => [`/api/invites/info`, ...(params ? [params] : [])];
/**
 * @summary 取得邀請資訊
 */
export const useInvitesGetInfo = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInvitesGetInfoKey(params) : null));
    const swrFn = () => invitesGetInfo(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesGetUrl = (inviteId) => {
    return createFullURL(`/api/invites/${inviteId}`);
};
export const invitesGet = async (inviteId, options) => {
    const res = await fetch(getInvitesGetUrl(inviteId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesGetKey = (inviteId) => [`/api/invites/${inviteId}`];
/**
 * @summary 取得單一邀請
 */
export const useInvitesGet = (inviteId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!inviteId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInvitesGetKey(inviteId) : null));
    const swrFn = () => invitesGet(inviteId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesDeleteUrl = (inviteId) => {
    return createFullURL(`/api/invites/${inviteId}`);
};
export const invitesDelete = async (inviteId, options) => {
    const res = await fetch(getInvitesDeleteUrl(inviteId), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesDeleteMutationFetcher = (inviteId, options) => {
    return (_, __) => {
        return invitesDelete(inviteId, options);
    };
};
export const getInvitesDeleteMutationKey = (inviteId) => [`/api/invites/${inviteId}`];
/**
 * @summary 刪除邀請
 */
export const useInvitesDelete = (inviteId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvitesDeleteMutationKey(inviteId);
    const swrFn = getInvitesDeleteMutationFetcher(inviteId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesAcceptByCodeUrl = (inviteCode) => {
    return createFullURL(`/api/invites/by-code/${inviteCode}/accept`);
};
export const invitesAcceptByCode = async (inviteCode, options) => {
    const res = await fetch(getInvitesAcceptByCodeUrl(inviteCode), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesAcceptByCodeMutationFetcher = (inviteCode, options) => {
    return (_, __) => {
        return invitesAcceptByCode(inviteCode, options);
    };
};
export const getInvitesAcceptByCodeMutationKey = (inviteCode) => [`/api/invites/by-code/${inviteCode}/accept`];
/**
 * @summary 透過邀請碼接受邀請
 */
export const useInvitesAcceptByCode = (inviteCode, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvitesAcceptByCodeMutationKey(inviteCode);
    const swrFn = getInvitesAcceptByCodeMutationFetcher(inviteCode, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesGetByTokenUrl = (token) => {
    return createFullURL(`/api/invites/link/${token}`);
};
export const invitesGetByToken = async (token, options) => {
    const res = await fetch(getInvitesGetByTokenUrl(token), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesGetByTokenKey = (token) => [`/api/invites/link/${token}`];
/**
 * @summary 取得邀請資訊
 */
export const useInvitesGetByToken = (token, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!token;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInvitesGetByTokenKey(token) : null));
    const swrFn = () => invitesGetByToken(token, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesAcceptUrl = () => {
    return createFullURL(`/api/invites/accept`);
};
export const invitesAccept = async (invitesAcceptBody, options) => {
    const res = await fetch(getInvitesAcceptUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(invitesAcceptBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesAcceptMutationFetcher = (options) => {
    return (_, { arg }) => {
        return invitesAccept(arg, options);
    };
};
export const getInvitesAcceptMutationKey = () => [`/api/invites/accept`];
/**
 * @summary 接受邀請
 */
export const useInvitesAccept = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvitesAcceptMutationKey();
    const swrFn = getInvitesAcceptMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvitesAcceptByTokenUrl = (token) => {
    return createFullURL(`/api/invites/link/${token}/accept`);
};
export const invitesAcceptByToken = async (token, options) => {
    const res = await fetch(getInvitesAcceptByTokenUrl(token), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvitesAcceptByTokenMutationFetcher = (token, options) => {
    return (_, __) => {
        return invitesAcceptByToken(token, options);
    };
};
export const getInvitesAcceptByTokenMutationKey = (token) => [`/api/invites/link/${token}/accept`];
/**
 * @summary 透過邀請連結接受邀請
 */
export const useInvitesAcceptByToken = (token, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvitesAcceptByTokenMutationKey(token);
    const swrFn = getInvitesAcceptByTokenMutationFetcher(token, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/products?${stringifiedParams}`)
        : createFullURL(`/api/products`);
};
export const productsList = async (params, options) => {
    const res = await fetch(getProductsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsListKey = (params) => [`/api/products`, ...(params ? [params] : [])];
/**
 * @summary 取得產品列表
 */
export const useProductsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getProductsListKey(params) : null));
    const swrFn = () => productsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsCreateUrl = () => {
    return createFullURL(`/api/products`);
};
export const productsCreate = async (productsCreateBody, options) => {
    const res = await fetch(getProductsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(productsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return productsCreate(arg, options);
    };
};
export const getProductsCreateMutationKey = () => [`/api/products`];
/**
 * @summary 建立產品
 */
export const useProductsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getProductsCreateMutationKey();
    const swrFn = getProductsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsGetCategoriesUrl = () => {
    return createFullURL(`/api/products/categories`);
};
export const productsGetCategories = async (options) => {
    const res = await fetch(getProductsGetCategoriesUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsGetCategoriesKey = () => [`/api/products/categories`];
/**
 * @summary 取得產品分類列表
 */
export const useProductsGetCategories = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getProductsGetCategoriesKey() : null));
    const swrFn = () => productsGetCategories(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsGetUrl = (id) => {
    return createFullURL(`/api/products/${id}`);
};
export const productsGet = async (id, options) => {
    const res = await fetch(getProductsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsGetKey = (id) => [`/api/products/${id}`];
/**
 * @summary 取得產品詳細資訊
 */
export const useProductsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getProductsGetKey(id) : null));
    const swrFn = () => productsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsUpdateUrl = (id) => {
    return createFullURL(`/api/products/${id}`);
};
export const productsUpdate = async (id, productsUpdateBody, options) => {
    const res = await fetch(getProductsUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(productsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return productsUpdate(id, arg, options);
    };
};
export const getProductsUpdateMutationKey = (id) => [`/api/products/${id}`];
/**
 * @summary 更新產品
 */
export const useProductsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getProductsUpdateMutationKey(id);
    const swrFn = getProductsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsDeleteUrl = (id) => {
    return createFullURL(`/api/products/${id}`);
};
export const productsDelete = async (id, options) => {
    const res = await fetch(getProductsDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return productsDelete(id, options);
    };
};
export const getProductsDeleteMutationKey = (id) => [`/api/products/${id}`];
/**
 * @summary 刪除產品
 */
export const useProductsDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getProductsDeleteMutationKey(id);
    const swrFn = getProductsDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getProductsGetBySkuUrl = (sku) => {
    return createFullURL(`/api/products/by-sku/${sku}`);
};
export const productsGetBySku = async (sku, options) => {
    const res = await fetch(getProductsGetBySkuUrl(sku), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getProductsGetBySkuKey = (sku) => [`/api/products/by-sku/${sku}`];
/**
 * @summary 依 SKU 取得產品
 */
export const useProductsGetBySku = (sku, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!sku;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getProductsGetBySkuKey(sku) : null));
    const swrFn = () => productsGetBySku(sku, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/discounts?${stringifiedParams}`)
        : createFullURL(`/api/discounts`);
};
export const discountsList = async (params, options) => {
    const res = await fetch(getDiscountsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsListKey = (params) => [`/api/discounts`, ...(params ? [params] : [])];
/**
 * @summary 取得折扣規則列表
 */
export const useDiscountsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getDiscountsListKey(params) : null));
    const swrFn = () => discountsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsCreateUrl = () => {
    return createFullURL(`/api/discounts`);
};
export const discountsCreate = async (discountsCreateBody, options) => {
    const res = await fetch(getDiscountsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(discountsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return discountsCreate(arg, options);
    };
};
export const getDiscountsCreateMutationKey = () => [`/api/discounts`];
/**
 * @summary 建立折扣規則
 */
export const useDiscountsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsCreateMutationKey();
    const swrFn = getDiscountsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsGetUrl = (id) => {
    return createFullURL(`/api/discounts/${id}`);
};
export const discountsGet = async (id, options) => {
    const res = await fetch(getDiscountsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsGetKey = (id) => [`/api/discounts/${id}`];
/**
 * @summary 取得單一折扣規則
 */
export const useDiscountsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDiscountsGetKey(id) : null));
    const swrFn = () => discountsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsUpdateUrl = (id) => {
    return createFullURL(`/api/discounts/${id}`);
};
export const discountsUpdate = async (id, discountsUpdateBody, options) => {
    const res = await fetch(getDiscountsUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(discountsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return discountsUpdate(id, arg, options);
    };
};
export const getDiscountsUpdateMutationKey = (id) => [`/api/discounts/${id}`];
/**
 * @summary 更新折扣規則
 */
export const useDiscountsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsUpdateMutationKey(id);
    const swrFn = getDiscountsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsDeleteUrl = (id) => {
    return createFullURL(`/api/discounts/${id}`);
};
export const discountsDelete = async (id, options) => {
    const res = await fetch(getDiscountsDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return discountsDelete(id, options);
    };
};
export const getDiscountsDeleteMutationKey = (id) => [`/api/discounts/${id}`];
/**
 * @summary 刪除折扣規則
 */
export const useDiscountsDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsDeleteMutationKey(id);
    const swrFn = getDiscountsDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsAttachProductsUrl = (id) => {
    return createFullURL(`/api/discounts/${id}/products`);
};
export const discountsAttachProducts = async (id, discountsAttachProductsBody, options) => {
    const res = await fetch(getDiscountsAttachProductsUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(discountsAttachProductsBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsAttachProductsMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return discountsAttachProducts(id, arg, options);
    };
};
export const getDiscountsAttachProductsMutationKey = (id) => [`/api/discounts/${id}/products`];
/**
 * @summary [已棄用] 將商品關聯到折扣規則
 */
export const useDiscountsAttachProducts = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsAttachProductsMutationKey(id);
    const swrFn = getDiscountsAttachProductsMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsDetachProductUrl = (id, productId) => {
    return createFullURL(`/api/discounts/${id}/products/${productId}`);
};
export const discountsDetachProduct = async (id, productId, options) => {
    const res = await fetch(getDiscountsDetachProductUrl(id, productId), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsDetachProductMutationFetcher = (id, productId, options) => {
    return (_, __) => {
        return discountsDetachProduct(id, productId, options);
    };
};
export const getDiscountsDetachProductMutationKey = (id, productId) => [`/api/discounts/${id}/products/${productId}`];
/**
 * @summary [已棄用] 移除商品與折扣規則的關聯
 */
export const useDiscountsDetachProduct = (id, productId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsDetachProductMutationKey(id, productId);
    const swrFn = getDiscountsDetachProductMutationFetcher(id, productId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getDiscountsCalculateCartUrl = () => {
    return createFullURL(`/api/discounts/calculate-cart`);
};
export const discountsCalculateCart = async (discountsCalculateCartBody, options) => {
    const res = await fetch(getDiscountsCalculateCartUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(discountsCalculateCartBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getDiscountsCalculateCartMutationFetcher = (options) => {
    return (_, { arg }) => {
        return discountsCalculateCart(arg, options);
    };
};
export const getDiscountsCalculateCartMutationKey = () => [`/api/discounts/calculate-cart`];
/**
 * @summary 計算購物車折扣
 */
export const useDiscountsCalculateCart = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getDiscountsCalculateCartMutationKey();
    const swrFn = getDiscountsCalculateCartMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPointsRulesListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/points-rules?${stringifiedParams}`)
        : createFullURL(`/api/points-rules`);
};
export const pointsRulesList = async (params, options) => {
    const res = await fetch(getPointsRulesListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPointsRulesListKey = (params) => [`/api/points-rules`, ...(params ? [params] : [])];
/**
 * @summary 取得點數規則列表
 */
export const usePointsRulesList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPointsRulesListKey(params) : null));
    const swrFn = () => pointsRulesList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPointsRulesCreateUrl = () => {
    return createFullURL(`/api/points-rules`);
};
export const pointsRulesCreate = async (pointsRulesCreateBody, options) => {
    const res = await fetch(getPointsRulesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pointsRulesCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPointsRulesCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return pointsRulesCreate(arg, options);
    };
};
export const getPointsRulesCreateMutationKey = () => [`/api/points-rules`];
/**
 * @summary 建立點數規則
 */
export const usePointsRulesCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPointsRulesCreateMutationKey();
    const swrFn = getPointsRulesCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPointsRulesGetUrl = (id) => {
    return createFullURL(`/api/points-rules/${id}`);
};
export const pointsRulesGet = async (id, options) => {
    const res = await fetch(getPointsRulesGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPointsRulesGetKey = (id) => [`/api/points-rules/${id}`];
/**
 * @summary 取得單一點數規則
 */
export const usePointsRulesGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getPointsRulesGetKey(id) : null));
    const swrFn = () => pointsRulesGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPointsRulesUpdateUrl = (id) => {
    return createFullURL(`/api/points-rules/${id}`);
};
export const pointsRulesUpdate = async (id, pointsRulesUpdateBody, options) => {
    const res = await fetch(getPointsRulesUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pointsRulesUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPointsRulesUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return pointsRulesUpdate(id, arg, options);
    };
};
export const getPointsRulesUpdateMutationKey = (id) => [`/api/points-rules/${id}`];
/**
 * @summary 更新點數規則
 */
export const usePointsRulesUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPointsRulesUpdateMutationKey(id);
    const swrFn = getPointsRulesUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPointsRulesDeleteUrl = (id) => {
    return createFullURL(`/api/points-rules/${id}`);
};
export const pointsRulesDelete = async (id, options) => {
    const res = await fetch(getPointsRulesDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPointsRulesDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return pointsRulesDelete(id, options);
    };
};
export const getPointsRulesDeleteMutationKey = (id) => [`/api/points-rules/${id}`];
/**
 * @summary 刪除點數規則
 */
export const usePointsRulesDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPointsRulesDeleteMutationKey(id);
    const swrFn = getPointsRulesDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMemberLevelsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/member-levels?${stringifiedParams}`)
        : createFullURL(`/api/member-levels`);
};
export const memberLevelsList = async (params, options) => {
    const res = await fetch(getMemberLevelsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMemberLevelsListKey = (params) => [`/api/member-levels`, ...(params ? [params] : [])];
/**
 * @summary 取得會員等級列表
 */
export const useMemberLevelsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getMemberLevelsListKey(params) : null));
    const swrFn = () => memberLevelsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMemberLevelsCreateUrl = () => {
    return createFullURL(`/api/member-levels`);
};
export const memberLevelsCreate = async (memberLevelsCreateBody, options) => {
    const res = await fetch(getMemberLevelsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(memberLevelsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMemberLevelsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return memberLevelsCreate(arg, options);
    };
};
export const getMemberLevelsCreateMutationKey = () => [`/api/member-levels`];
/**
 * @summary 建立會員等級
 */
export const useMemberLevelsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMemberLevelsCreateMutationKey();
    const swrFn = getMemberLevelsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMemberLevelsGetUrl = (id) => {
    return createFullURL(`/api/member-levels/${id}`);
};
export const memberLevelsGet = async (id, options) => {
    const res = await fetch(getMemberLevelsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMemberLevelsGetKey = (id) => [`/api/member-levels/${id}`];
/**
 * @summary 取得單一會員等級
 */
export const useMemberLevelsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getMemberLevelsGetKey(id) : null));
    const swrFn = () => memberLevelsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMemberLevelsUpdateUrl = (id) => {
    return createFullURL(`/api/member-levels/${id}`);
};
export const memberLevelsUpdate = async (id, memberLevelsUpdateBody, options) => {
    const res = await fetch(getMemberLevelsUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(memberLevelsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMemberLevelsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return memberLevelsUpdate(id, arg, options);
    };
};
export const getMemberLevelsUpdateMutationKey = (id) => [`/api/member-levels/${id}`];
/**
 * @summary 更新會員等級
 */
export const useMemberLevelsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMemberLevelsUpdateMutationKey(id);
    const swrFn = getMemberLevelsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getMemberLevelsDeleteUrl = (id) => {
    return createFullURL(`/api/member-levels/${id}`);
};
export const memberLevelsDelete = async (id, options) => {
    const res = await fetch(getMemberLevelsDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getMemberLevelsDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return memberLevelsDelete(id, options);
    };
};
export const getMemberLevelsDeleteMutationKey = (id) => [`/api/member-levels/${id}`];
/**
 * @summary 刪除會員等級
 */
export const useMemberLevelsDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getMemberLevelsDeleteMutationKey(id);
    const swrFn = getMemberLevelsDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAvailabilitiesListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/availabilities?${stringifiedParams}`)
        : createFullURL(`/api/availabilities`);
};
export const availabilitiesList = async (params, options) => {
    const res = await fetch(getAvailabilitiesListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAvailabilitiesListKey = (params) => [`/api/availabilities`, ...(params ? [params] : [])];
/**
 * @summary 取得可用時段列表
 */
export const useAvailabilitiesList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAvailabilitiesListKey(params) : null));
    const swrFn = () => availabilitiesList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAvailabilitiesCreateUrl = () => {
    return createFullURL(`/api/availabilities`);
};
export const availabilitiesCreate = async (availabilitiesCreateBody, options) => {
    const res = await fetch(getAvailabilitiesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(availabilitiesCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAvailabilitiesCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return availabilitiesCreate(arg, options);
    };
};
export const getAvailabilitiesCreateMutationKey = () => [`/api/availabilities`];
/**
 * @summary 建立可用時段
 */
export const useAvailabilitiesCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAvailabilitiesCreateMutationKey();
    const swrFn = getAvailabilitiesCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAvailabilitiesGetAvailableSlotsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/availabilities/available-slots?${stringifiedParams}`)
        : createFullURL(`/api/availabilities/available-slots`);
};
export const availabilitiesGetAvailableSlots = async (params, options) => {
    const res = await fetch(getAvailabilitiesGetAvailableSlotsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAvailabilitiesGetAvailableSlotsKey = (params) => [`/api/availabilities/available-slots`, ...(params ? [params] : [])];
/**
 * @summary 查詢特定日期的可用時段
 */
export const useAvailabilitiesGetAvailableSlots = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAvailabilitiesGetAvailableSlotsKey(params) : null));
    const swrFn = () => availabilitiesGetAvailableSlots(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAvailabilitiesUpdateUrl = (id) => {
    return createFullURL(`/api/availabilities/${id}`);
};
export const availabilitiesUpdate = async (id, availabilitiesUpdateBody, options) => {
    const res = await fetch(getAvailabilitiesUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(availabilitiesUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAvailabilitiesUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return availabilitiesUpdate(id, arg, options);
    };
};
export const getAvailabilitiesUpdateMutationKey = (id) => [`/api/availabilities/${id}`];
/**
 * @summary 更新可用時段
 */
export const useAvailabilitiesUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAvailabilitiesUpdateMutationKey(id);
    const swrFn = getAvailabilitiesUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAvailabilitiesDeleteUrl = (id) => {
    return createFullURL(`/api/availabilities/${id}`);
};
export const availabilitiesDelete = async (id, options) => {
    const res = await fetch(getAvailabilitiesDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAvailabilitiesDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return availabilitiesDelete(id, options);
    };
};
export const getAvailabilitiesDeleteMutationKey = (id) => [`/api/availabilities/${id}`];
/**
 * @summary 刪除可用時段
 */
export const useAvailabilitiesDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAvailabilitiesDeleteMutationKey(id);
    const swrFn = getAvailabilitiesDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/coupons?${stringifiedParams}`)
        : createFullURL(`/api/coupons`);
};
export const couponsList = async (params, options) => {
    const res = await fetch(getCouponsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponsListKey = (params) => [`/api/coupons`, ...(params ? [params] : [])];
/**
 * @summary 取得優惠券列表
 */
export const useCouponsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getCouponsListKey(params) : null));
    const swrFn = () => couponsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponsCreateUrl = () => {
    return createFullURL(`/api/coupons`);
};
export const couponsCreate = async (couponsCreateBody, options) => {
    const res = await fetch(getCouponsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(couponsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return couponsCreate(arg, options);
    };
};
export const getCouponsCreateMutationKey = () => [`/api/coupons`];
/**
 * @summary 建立優惠券
 */
export const useCouponsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponsCreateMutationKey();
    const swrFn = getCouponsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponsGetUrl = (id) => {
    return createFullURL(`/api/coupons/${id}`);
};
export const couponsGet = async (id, options) => {
    const res = await fetch(getCouponsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponsGetKey = (id) => [`/api/coupons/${id}`];
/**
 * @summary 取得單一優惠券
 */
export const useCouponsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getCouponsGetKey(id) : null));
    const swrFn = () => couponsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponsUpdateUrl = (id) => {
    return createFullURL(`/api/coupons/${id}`);
};
export const couponsUpdate = async (id, couponsUpdateBody, options) => {
    const res = await fetch(getCouponsUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(couponsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return couponsUpdate(id, arg, options);
    };
};
export const getCouponsUpdateMutationKey = (id) => [`/api/coupons/${id}`];
/**
 * @summary 更新優惠券
 */
export const useCouponsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponsUpdateMutationKey(id);
    const swrFn = getCouponsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponsDeleteUrl = (id) => {
    return createFullURL(`/api/coupons/${id}`);
};
export const couponsDelete = async (id, options) => {
    const res = await fetch(getCouponsDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponsDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return couponsDelete(id, options);
    };
};
export const getCouponsDeleteMutationKey = (id) => [`/api/coupons/${id}`];
/**
 * @summary 刪除優惠券
 */
export const useCouponsDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponsDeleteMutationKey(id);
    const swrFn = getCouponsDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponCodesListUrl = (id) => {
    return createFullURL(`/api/coupons/${id}/codes`);
};
export const couponCodesList = async (id, options) => {
    const res = await fetch(getCouponCodesListUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponCodesListKey = (id) => [`/api/coupons/${id}/codes`];
/**
 * @summary 取得優惠券代碼列表
 */
export const useCouponCodesList = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getCouponCodesListKey(id) : null));
    const swrFn = () => couponCodesList(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponCodesCreateUrl = (id) => {
    return createFullURL(`/api/coupons/${id}/codes`);
};
export const couponCodesCreate = async (id, couponCodesCreateBody, options) => {
    const res = await fetch(getCouponCodesCreateUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(couponCodesCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponCodesCreateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return couponCodesCreate(id, arg, options);
    };
};
export const getCouponCodesCreateMutationKey = (id) => [`/api/coupons/${id}/codes`];
/**
 * @summary 建立優惠券代碼
 */
export const useCouponCodesCreate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponCodesCreateMutationKey(id);
    const swrFn = getCouponCodesCreateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponCodesUpdateUrl = (codeId) => {
    return createFullURL(`/api/coupon-codes/${codeId}`);
};
export const couponCodesUpdate = async (codeId, couponCodesUpdateBody, options) => {
    const res = await fetch(getCouponCodesUpdateUrl(codeId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(couponCodesUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponCodesUpdateMutationFetcher = (codeId, options) => {
    return (_, { arg }) => {
        return couponCodesUpdate(codeId, arg, options);
    };
};
export const getCouponCodesUpdateMutationKey = (codeId) => [`/api/coupon-codes/${codeId}`];
/**
 * @summary 更新優惠券代碼
 */
export const useCouponCodesUpdate = (codeId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponCodesUpdateMutationKey(codeId);
    const swrFn = getCouponCodesUpdateMutationFetcher(codeId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponCodesDeleteUrl = (codeId) => {
    return createFullURL(`/api/coupon-codes/${codeId}`);
};
export const couponCodesDelete = async (codeId, options) => {
    const res = await fetch(getCouponCodesDeleteUrl(codeId), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponCodesDeleteMutationFetcher = (codeId, options) => {
    return (_, __) => {
        return couponCodesDelete(codeId, options);
    };
};
export const getCouponCodesDeleteMutationKey = (codeId) => [`/api/coupon-codes/${codeId}`];
/**
 * @summary 刪除優惠券代碼
 */
export const useCouponCodesDelete = (codeId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponCodesDeleteMutationKey(codeId);
    const swrFn = getCouponCodesDeleteMutationFetcher(codeId, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getCouponGrantsCreateUrl = () => {
    return createFullURL(`/api/coupon-grants`);
};
export const couponGrantsCreate = async (couponGrantsCreateBody, options) => {
    const res = await fetch(getCouponGrantsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(couponGrantsCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getCouponGrantsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return couponGrantsCreate(arg, options);
    };
};
export const getCouponGrantsCreateMutationKey = () => [`/api/coupon-grants`];
/**
 * @summary 發券
 */
export const useCouponGrantsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getCouponGrantsCreateMutationKey();
    const swrFn = getCouponGrantsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/orders?${stringifiedParams}`)
        : createFullURL(`/api/orders`);
};
export const ordersList = async (params, options) => {
    const res = await fetch(getOrdersListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersListKey = (params) => [`/api/orders`, ...(params ? [params] : [])];
/**
 * @summary 取得訂單列表
 */
export const useOrdersList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getOrdersListKey(params) : null));
    const swrFn = () => ordersList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersCreateUrl = () => {
    return createFullURL(`/api/orders`);
};
export const ordersCreate = async (ordersCreateBody, options) => {
    const res = await fetch(getOrdersCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ordersCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return ordersCreate(arg, options);
    };
};
export const getOrdersCreateMutationKey = () => [`/api/orders`];
/**
 * @summary 建立訂單
 */
export const useOrdersCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getOrdersCreateMutationKey();
    const swrFn = getOrdersCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersGetUrl = (id) => {
    return createFullURL(`/api/orders/${id}`);
};
export const ordersGet = async (id, options) => {
    const res = await fetch(getOrdersGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersGetKey = (id) => [`/api/orders/${id}`];
/**
 * @summary 取得訂單詳細資訊
 */
export const useOrdersGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getOrdersGetKey(id) : null));
    const swrFn = () => ordersGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersUpdateStatusUrl = (id) => {
    return createFullURL(`/api/orders/${id}/status`);
};
export const ordersUpdateStatus = async (id, ordersUpdateStatusBody, options) => {
    const res = await fetch(getOrdersUpdateStatusUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(ordersUpdateStatusBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersUpdateStatusMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return ordersUpdateStatus(id, arg, options);
    };
};
export const getOrdersUpdateStatusMutationKey = (id) => [`/api/orders/${id}/status`];
/**
 * @summary 更新訂單狀態
 */
export const useOrdersUpdateStatus = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getOrdersUpdateStatusMutationKey(id);
    const swrFn = getOrdersUpdateStatusMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersCancelUrl = (id) => {
    return createFullURL(`/api/orders/${id}/cancel`);
};
export const ordersCancel = async (id, options) => {
    const res = await fetch(getOrdersCancelUrl(id), {
        ...options,
        method: 'PUT',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersCancelMutationFetcher = (id, options) => {
    return (_, __) => {
        return ordersCancel(id, options);
    };
};
export const getOrdersCancelMutationKey = (id) => [`/api/orders/${id}/cancel`];
/**
 * @summary 取消訂單
 */
export const useOrdersCancel = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getOrdersCancelMutationKey(id);
    const swrFn = getOrdersCancelMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersGetByNumberUrl = (orderNumber) => {
    return createFullURL(`/api/orders/number/${orderNumber}`);
};
export const ordersGetByNumber = async (orderNumber, options) => {
    const res = await fetch(getOrdersGetByNumberUrl(orderNumber), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersGetByNumberKey = (orderNumber) => [`/api/orders/number/${orderNumber}`];
/**
 * @summary 根據訂單編號取得訂單
 */
export const useOrdersGetByNumber = (orderNumber, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!orderNumber;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getOrdersGetByNumberKey(orderNumber) : null));
    const swrFn = () => ordersGetByNumber(orderNumber, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersGetByUserUrl = (userId, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/users/${userId}/orders?${stringifiedParams}`)
        : createFullURL(`/api/users/${userId}/orders`);
};
export const ordersGetByUser = async (userId, params, options) => {
    const res = await fetch(getOrdersGetByUserUrl(userId, params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersGetByUserKey = (userId, params) => [`/api/users/${userId}/orders`, ...(params ? [params] : [])];
/**
 * @summary 取得使用者的訂單列表
 */
export const useOrdersGetByUser = (userId, params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!userId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getOrdersGetByUserKey(userId, params) : null));
    const swrFn = () => ordersGetByUser(userId, params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOrdersGetTodayStatsUrl = () => {
    return createFullURL(`/api/orders/stats/today`);
};
export const ordersGetTodayStats = async (options) => {
    const res = await fetch(getOrdersGetTodayStatsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOrdersGetTodayStatsKey = () => [`/api/orders/stats/today`];
/**
 * @summary 取得今日訂單統計
 */
export const useOrdersGetTodayStats = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getOrdersGetTodayStatsKey() : null));
    const swrFn = () => ordersGetTodayStats(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInvoicesVoidUrl = (id) => {
    return createFullURL(`/api/invoices/${id}/void`);
};
export const invoicesVoid = async (id, invoicesVoidBody, options) => {
    const res = await fetch(getInvoicesVoidUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(invoicesVoidBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInvoicesVoidMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return invoicesVoid(id, arg, options);
    };
};
export const getInvoicesVoidMutationKey = (id) => [`/api/invoices/${id}/void`];
/**
 * @summary 作廢發票
 */
export const useInvoicesVoid = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInvoicesVoidMutationKey(id);
    const swrFn = getInvoicesVoidMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPackagesRedeemUrl = (id) => {
    return createFullURL(`/api/packages/${id}/redeem`);
};
export const packagesRedeem = async (id, packagesRedeemBody, options) => {
    const res = await fetch(getPackagesRedeemUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(packagesRedeemBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPackagesRedeemMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return packagesRedeem(id, arg, options);
    };
};
export const getPackagesRedeemMutationKey = (id) => [`/api/packages/${id}/redeem`];
/**
 * @summary 核銷票券
 */
export const usePackagesRedeem = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPackagesRedeemMutationKey(id);
    const swrFn = getPackagesRedeemMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAppointmentsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/appointments?${stringifiedParams}`)
        : createFullURL(`/api/appointments`);
};
export const appointmentsList = async (params, options) => {
    const res = await fetch(getAppointmentsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAppointmentsListKey = (params) => [`/api/appointments`, ...(params ? [params] : [])];
/**
 * @summary 取得預約列表
 */
export const useAppointmentsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAppointmentsListKey(params) : null));
    const swrFn = () => appointmentsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAppointmentsCreateUrl = () => {
    return createFullURL(`/api/appointments`);
};
export const appointmentsCreate = async (createAppointmentRequest, options) => {
    const res = await fetch(getAppointmentsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createAppointmentRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAppointmentsCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return appointmentsCreate(arg, options);
    };
};
export const getAppointmentsCreateMutationKey = () => [`/api/appointments`];
/**
 * @summary 建立預約
 */
export const useAppointmentsCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAppointmentsCreateMutationKey();
    const swrFn = getAppointmentsCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAppointmentsGetUrl = (id) => {
    return createFullURL(`/api/appointments/${id}`);
};
export const appointmentsGet = async (id, options) => {
    const res = await fetch(getAppointmentsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAppointmentsGetKey = (id) => [`/api/appointments/${id}`];
/**
 * @summary 取得單一預約
 */
export const useAppointmentsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getAppointmentsGetKey(id) : null));
    const swrFn = () => appointmentsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAppointmentsUpdateUrl = (id) => {
    return createFullURL(`/api/appointments/${id}`);
};
export const appointmentsUpdate = async (id, updateAppointmentRequest, options) => {
    const res = await fetch(getAppointmentsUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateAppointmentRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAppointmentsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return appointmentsUpdate(id, arg, options);
    };
};
export const getAppointmentsUpdateMutationKey = (id) => [`/api/appointments/${id}`];
/**
 * @summary 更新預約
 */
export const useAppointmentsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAppointmentsUpdateMutationKey(id);
    const swrFn = getAppointmentsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAppointmentsCheckInUrl = (id) => {
    return createFullURL(`/api/appointments/${id}/check-in`);
};
export const appointmentsCheckIn = async (id, checkInRequest, options) => {
    const res = await fetch(getAppointmentsCheckInUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(checkInRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAppointmentsCheckInMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return appointmentsCheckIn(id, arg, options);
    };
};
export const getAppointmentsCheckInMutationKey = (id) => [`/api/appointments/${id}/check-in`];
/**
 * @summary 簽到核銷
 */
export const useAppointmentsCheckIn = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAppointmentsCheckInMutationKey(id);
    const swrFn = getAppointmentsCheckInMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getShipmentsListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/shipments?${stringifiedParams}`)
        : createFullURL(`/api/shipments`);
};
export const shipmentsList = async (params, options) => {
    const res = await fetch(getShipmentsListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getShipmentsListKey = (params) => [`/api/shipments`, ...(params ? [params] : [])];
/**
 * @summary 取得出貨單列表
 */
export const useShipmentsList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getShipmentsListKey(params) : null));
    const swrFn = () => shipmentsList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getShipmentsSyncMissingUrl = () => {
    return createFullURL(`/api/shipments/sync-missing`);
};
export const shipmentsSyncMissing = async (options) => {
    const res = await fetch(getShipmentsSyncMissingUrl(), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getShipmentsSyncMissingMutationFetcher = (options) => {
    return (_, __) => {
        return shipmentsSyncMissing(options);
    };
};
export const getShipmentsSyncMissingMutationKey = () => [`/api/shipments/sync-missing`];
/**
 * @summary 補建缺漏的出貨單
 */
export const useShipmentsSyncMissing = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getShipmentsSyncMissingMutationKey();
    const swrFn = getShipmentsSyncMissingMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getShipmentsGetUrl = (id) => {
    return createFullURL(`/api/shipments/${id}`);
};
export const shipmentsGet = async (id, options) => {
    const res = await fetch(getShipmentsGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getShipmentsGetKey = (id) => [`/api/shipments/${id}`];
/**
 * @summary 取得出貨單詳細資訊
 */
export const useShipmentsGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getShipmentsGetKey(id) : null));
    const swrFn = () => shipmentsGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getShipmentsUpdateUrl = (id) => {
    return createFullURL(`/api/shipments/${id}`);
};
export const shipmentsUpdate = async (id, shipmentsUpdateBody, options) => {
    const res = await fetch(getShipmentsUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(shipmentsUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getShipmentsUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return shipmentsUpdate(id, arg, options);
    };
};
export const getShipmentsUpdateMutationKey = (id) => [`/api/shipments/${id}`];
/**
 * @summary 更新出貨單
 */
export const useShipmentsUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getShipmentsUpdateMutationKey(id);
    const swrFn = getShipmentsUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getShipmentsCreateLogisticsUrl = (id) => {
    return createFullURL(`/api/shipments/${id}/create-logistics`);
};
export const shipmentsCreateLogistics = async (id, shipmentsCreateLogisticsBody, options) => {
    const res = await fetch(getShipmentsCreateLogisticsUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(shipmentsCreateLogisticsBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getShipmentsCreateLogisticsMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return shipmentsCreateLogistics(id, arg, options);
    };
};
export const getShipmentsCreateLogisticsMutationKey = (id) => [`/api/shipments/${id}/create-logistics`];
/**
 * @summary 建立綠界物流訂單
 */
export const useShipmentsCreateLogistics = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getShipmentsCreateLogisticsMutationKey(id);
    const swrFn = getShipmentsCreateLogisticsMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuppliersListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/suppliers?${stringifiedParams}`)
        : createFullURL(`/api/suppliers`);
};
export const suppliersList = async (params, options) => {
    const res = await fetch(getSuppliersListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuppliersListKey = (params) => [`/api/suppliers`, ...(params ? [params] : [])];
/**
 * @summary 取得供應商列表
 */
export const useSuppliersList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSuppliersListKey(params) : null));
    const swrFn = () => suppliersList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuppliersCreateUrl = () => {
    return createFullURL(`/api/suppliers`);
};
export const suppliersCreate = async (suppliersCreateBody, options) => {
    const res = await fetch(getSuppliersCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(suppliersCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuppliersCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return suppliersCreate(arg, options);
    };
};
export const getSuppliersCreateMutationKey = () => [`/api/suppliers`];
/**
 * @summary 建立供應商
 */
export const useSuppliersCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuppliersCreateMutationKey();
    const swrFn = getSuppliersCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuppliersGetUrl = (id) => {
    return createFullURL(`/api/suppliers/${id}`);
};
export const suppliersGet = async (id, options) => {
    const res = await fetch(getSuppliersGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuppliersGetKey = (id) => [`/api/suppliers/${id}`];
/**
 * @summary 取得單一供應商
 */
export const useSuppliersGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getSuppliersGetKey(id) : null));
    const swrFn = () => suppliersGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuppliersUpdateUrl = (id) => {
    return createFullURL(`/api/suppliers/${id}`);
};
export const suppliersUpdate = async (id, suppliersUpdateBody, options) => {
    const res = await fetch(getSuppliersUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(suppliersUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuppliersUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return suppliersUpdate(id, arg, options);
    };
};
export const getSuppliersUpdateMutationKey = (id) => [`/api/suppliers/${id}`];
/**
 * @summary 更新供應商
 */
export const useSuppliersUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuppliersUpdateMutationKey(id);
    const swrFn = getSuppliersUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSuppliersDeleteUrl = (id) => {
    return createFullURL(`/api/suppliers/${id}`);
};
export const suppliersDelete = async (id, options) => {
    const res = await fetch(getSuppliersDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSuppliersDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return suppliersDelete(id, options);
    };
};
export const getSuppliersDeleteMutationKey = (id) => [`/api/suppliers/${id}`];
/**
 * @summary 刪除供應商
 */
export const useSuppliersDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSuppliersDeleteMutationKey(id);
    const swrFn = getSuppliersDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInventoryLogsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/inventory/logs?${stringifiedParams}`)
        : createFullURL(`/api/inventory/logs`);
};
export const inventoryLogs = async (params, options) => {
    const res = await fetch(getInventoryLogsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInventoryLogsKey = (params) => [`/api/inventory/logs`, ...(params ? [params] : [])];
/**
 * @summary 查詢庫存異動紀錄
 */
export const useInventoryLogs = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInventoryLogsKey(params) : null));
    const swrFn = () => inventoryLogs(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInventoryAdjustUrl = () => {
    return createFullURL(`/api/inventory/adjust`);
};
export const inventoryAdjust = async (inventoryAdjustBody, options) => {
    const res = await fetch(getInventoryAdjustUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(inventoryAdjustBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInventoryAdjustMutationFetcher = (options) => {
    return (_, { arg }) => {
        return inventoryAdjust(arg, options);
    };
};
export const getInventoryAdjustMutationKey = () => [`/api/inventory/adjust`];
/**
 * @summary 盤點調整
 */
export const useInventoryAdjust = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getInventoryAdjustMutationKey();
    const swrFn = getInventoryAdjustMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getInventoryLowStockUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/inventory/low-stock?${stringifiedParams}`)
        : createFullURL(`/api/inventory/low-stock`);
};
export const inventoryLowStock = async (params, options) => {
    const res = await fetch(getInventoryLowStockUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getInventoryLowStockKey = (params) => [`/api/inventory/low-stock`, ...(params ? [params] : [])];
/**
 * @summary 查詢低庫存商品
 */
export const useInventoryLowStock = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getInventoryLowStockKey(params) : null));
    const swrFn = () => inventoryLowStock(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/purchase-orders?${stringifiedParams}`)
        : createFullURL(`/api/purchase-orders`);
};
export const purchaseOrdersList = async (params, options) => {
    const res = await fetch(getPurchaseOrdersListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersListKey = (params) => [`/api/purchase-orders`, ...(params ? [params] : [])];
/**
 * @summary 取得進貨單列表
 */
export const usePurchaseOrdersList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPurchaseOrdersListKey(params) : null));
    const swrFn = () => purchaseOrdersList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersCreateUrl = () => {
    return createFullURL(`/api/purchase-orders`);
};
export const purchaseOrdersCreate = async (purchaseOrdersCreateBody, options) => {
    const res = await fetch(getPurchaseOrdersCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(purchaseOrdersCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return purchaseOrdersCreate(arg, options);
    };
};
export const getPurchaseOrdersCreateMutationKey = () => [`/api/purchase-orders`];
/**
 * @summary 建立進貨單
 */
export const usePurchaseOrdersCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPurchaseOrdersCreateMutationKey();
    const swrFn = getPurchaseOrdersCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersGetUrl = (id) => {
    return createFullURL(`/api/purchase-orders/${id}`);
};
export const purchaseOrdersGet = async (id, options) => {
    const res = await fetch(getPurchaseOrdersGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersGetKey = (id) => [`/api/purchase-orders/${id}`];
/**
 * @summary 取得單一進貨單
 */
export const usePurchaseOrdersGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPurchaseOrdersGetKey(id) : null));
    const swrFn = () => purchaseOrdersGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersUpdateUrl = (id) => {
    return createFullURL(`/api/purchase-orders/${id}`);
};
export const purchaseOrdersUpdate = async (id, purchaseOrdersUpdateBody, options) => {
    const res = await fetch(getPurchaseOrdersUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(purchaseOrdersUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return purchaseOrdersUpdate(id, arg, options);
    };
};
export const getPurchaseOrdersUpdateMutationKey = (id) => [`/api/purchase-orders/${id}`];
/**
 * @summary 更新進貨單
 */
export const usePurchaseOrdersUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPurchaseOrdersUpdateMutationKey(id);
    const swrFn = getPurchaseOrdersUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersReceiveUrl = (id) => {
    return createFullURL(`/api/purchase-orders/${id}/receive`);
};
export const purchaseOrdersReceive = async (id, purchaseOrdersReceiveBody, options) => {
    const res = await fetch(getPurchaseOrdersReceiveUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(purchaseOrdersReceiveBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersReceiveMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return purchaseOrdersReceive(id, arg, options);
    };
};
export const getPurchaseOrdersReceiveMutationKey = (id) => [`/api/purchase-orders/${id}/receive`];
/**
 * @summary 確認入庫
 */
export const usePurchaseOrdersReceive = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPurchaseOrdersReceiveMutationKey(id);
    const swrFn = getPurchaseOrdersReceiveMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPurchaseOrdersCancelUrl = (id) => {
    return createFullURL(`/api/purchase-orders/${id}/cancel`);
};
export const purchaseOrdersCancel = async (id, options) => {
    const res = await fetch(getPurchaseOrdersCancelUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPurchaseOrdersCancelMutationFetcher = (id, options) => {
    return (_, __) => {
        return purchaseOrdersCancel(id, options);
    };
};
export const getPurchaseOrdersCancelMutationKey = (id) => [`/api/purchase-orders/${id}/cancel`];
/**
 * @summary 取消進貨單
 */
export const usePurchaseOrdersCancel = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPurchaseOrdersCancelMutationKey(id);
    const swrFn = getPurchaseOrdersCancelMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveysCreateUrl = () => {
    return createFullURL(`/api/surveys`);
};
export const surveysCreate = async (createSurveyRequest, options) => {
    const res = await fetch(getSurveysCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createSurveyRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveysCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return surveysCreate(arg, options);
    };
};
export const getSurveysCreateMutationKey = () => [`/api/surveys`];
/**
 * @summary 提交問卷
 */
export const useSurveysCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveysCreateMutationKey();
    const swrFn = getSurveysCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveysListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/surveys?${stringifiedParams}`)
        : createFullURL(`/api/surveys`);
};
export const surveysList = async (params, options) => {
    const res = await fetch(getSurveysListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveysListKey = (params) => [`/api/surveys`, ...(params ? [params] : [])];
/**
 * @summary 查詢問卷列表
 */
export const useSurveysList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSurveysListKey(params) : null));
    const swrFn = () => surveysList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveysGetByPhoneUrl = (memberId) => {
    return createFullURL(`/api/surveys/by-phone/${memberId}`);
};
export const surveysGetByPhone = async (memberId, options) => {
    const res = await fetch(getSurveysGetByPhoneUrl(memberId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveysGetByPhoneKey = (memberId) => [`/api/surveys/by-phone/${memberId}`];
/**
 * @summary 查詢問卷
 */
export const useSurveysGetByPhone = (memberId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!memberId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSurveysGetByPhoneKey(memberId) : null));
    const swrFn = () => surveysGetByPhone(memberId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveysGetStatsUrl = () => {
    return createFullURL(`/api/surveys/stats/summary`);
};
export const surveysGetStats = async (options) => {
    const res = await fetch(getSurveysGetStatsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveysGetStatsKey = () => [`/api/surveys/stats/summary`];
/**
 * @summary 問卷統計
 */
export const useSurveysGetStats = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getSurveysGetStatsKey() : null));
    const swrFn = () => surveysGetStats(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveysDeleteUrl = (id) => {
    return createFullURL(`/api/surveys/${id}`);
};
export const surveysDelete = async (id, options) => {
    const res = await fetch(getSurveysDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveysDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return surveysDelete(id, options);
    };
};
export const getSurveysDeleteMutationKey = (id) => [`/api/surveys/${id}`];
/**
 * @summary 刪除問卷
 */
export const useSurveysDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveysDeleteMutationKey(id);
    const swrFn = getSurveysDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesGetActiveUrl = () => {
    return createFullURL(`/api/survey-templates/active`);
};
export const surveyTemplatesGetActive = async (options) => {
    const res = await fetch(getSurveyTemplatesGetActiveUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesGetActiveKey = () => [`/api/survey-templates/active`];
/**
 * @summary 取得啟用的問卷模板
 */
export const useSurveyTemplatesGetActive = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSurveyTemplatesGetActiveKey() : null));
    const swrFn = () => surveyTemplatesGetActive(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesListUrl = () => {
    return createFullURL(`/api/survey-templates`);
};
export const surveyTemplatesList = async (options) => {
    const res = await fetch(getSurveyTemplatesListUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesListKey = () => [`/api/survey-templates`];
/**
 * @summary 列出所有問卷模板
 */
export const useSurveyTemplatesList = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSurveyTemplatesListKey() : null));
    const swrFn = () => surveyTemplatesList(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesCreateUrl = () => {
    return createFullURL(`/api/survey-templates`);
};
export const surveyTemplatesCreate = async (createSurveyTemplateRequest, options) => {
    const res = await fetch(getSurveyTemplatesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createSurveyTemplateRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return surveyTemplatesCreate(arg, options);
    };
};
export const getSurveyTemplatesCreateMutationKey = () => [`/api/survey-templates`];
/**
 * @summary 建立問卷模板
 */
export const useSurveyTemplatesCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesCreateMutationKey();
    const swrFn = getSurveyTemplatesCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesGetUrl = (id) => {
    return createFullURL(`/api/survey-templates/${id}`);
};
export const surveyTemplatesGet = async (id, options) => {
    const res = await fetch(getSurveyTemplatesGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesGetKey = (id) => [`/api/survey-templates/${id}`];
/**
 * @summary 取得特定問卷模板
 */
export const useSurveyTemplatesGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getSurveyTemplatesGetKey(id) : null));
    const swrFn = () => surveyTemplatesGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesUpdateUrl = (id) => {
    return createFullURL(`/api/survey-templates/${id}`);
};
export const surveyTemplatesUpdate = async (id, updateSurveyTemplateRequest, options) => {
    const res = await fetch(getSurveyTemplatesUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(updateSurveyTemplateRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return surveyTemplatesUpdate(id, arg, options);
    };
};
export const getSurveyTemplatesUpdateMutationKey = (id) => [`/api/survey-templates/${id}`];
/**
 * @summary 更新問卷模板
 */
export const useSurveyTemplatesUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesUpdateMutationKey(id);
    const swrFn = getSurveyTemplatesUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesDeleteUrl = (id) => {
    return createFullURL(`/api/survey-templates/${id}`);
};
export const surveyTemplatesDelete = async (id, options) => {
    const res = await fetch(getSurveyTemplatesDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return surveyTemplatesDelete(id, options);
    };
};
export const getSurveyTemplatesDeleteMutationKey = (id) => [`/api/survey-templates/${id}`];
/**
 * @summary 刪除問卷模板
 */
export const useSurveyTemplatesDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesDeleteMutationKey(id);
    const swrFn = getSurveyTemplatesDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesActivateUrl = (id) => {
    return createFullURL(`/api/survey-templates/${id}/activate`);
};
export const surveyTemplatesActivate = async (id, options) => {
    const res = await fetch(getSurveyTemplatesActivateUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesActivateMutationFetcher = (id, options) => {
    return (_, __) => {
        return surveyTemplatesActivate(id, options);
    };
};
export const getSurveyTemplatesActivateMutationKey = (id) => [`/api/survey-templates/${id}/activate`];
/**
 * @summary 啟用問卷模板
 */
export const useSurveyTemplatesActivate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesActivateMutationKey(id);
    const swrFn = getSurveyTemplatesActivateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesDeactivateUrl = (id) => {
    return createFullURL(`/api/survey-templates/${id}/deactivate`);
};
export const surveyTemplatesDeactivate = async (id, options) => {
    const res = await fetch(getSurveyTemplatesDeactivateUrl(id), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesDeactivateMutationFetcher = (id, options) => {
    return (_, __) => {
        return surveyTemplatesDeactivate(id, options);
    };
};
export const getSurveyTemplatesDeactivateMutationKey = (id) => [`/api/survey-templates/${id}/deactivate`];
/**
 * @summary 停用問卷模板
 */
export const useSurveyTemplatesDeactivate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesDeactivateMutationKey(id);
    const swrFn = getSurveyTemplatesDeactivateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getSurveyTemplatesConvertUrl = () => {
    return createFullURL(`/api/survey-templates/convert`);
};
export const surveyTemplatesConvert = async (convertSurveyRequest, options) => {
    const res = await fetch(getSurveyTemplatesConvertUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(convertSurveyRequest),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getSurveyTemplatesConvertMutationFetcher = (options) => {
    return (_, { arg }) => {
        return surveyTemplatesConvert(arg, options);
    };
};
export const getSurveyTemplatesConvertMutationKey = () => [`/api/survey-templates/convert`];
/**
 * @summary AI 轉換問卷內容
 */
export const useSurveyTemplatesConvert = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getSurveyTemplatesConvertMutationKey();
    const swrFn = getSurveyTemplatesConvertMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminListUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/admin/preorders?${stringifiedParams}`)
        : createFullURL(`/api/admin/preorders`);
};
export const preordersAdminList = async (params, options) => {
    const res = await fetch(getPreordersAdminListUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminListKey = (params) => [`/api/admin/preorders`, ...(params ? [params] : [])];
/**
 * @summary 取得預購檔期列表
 */
export const usePreordersAdminList = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPreordersAdminListKey(params) : null));
    const swrFn = () => preordersAdminList(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminCreateUrl = () => {
    return createFullURL(`/api/admin/preorders`);
};
export const preordersAdminCreate = async (preordersAdminCreateBody, options) => {
    const res = await fetch(getPreordersAdminCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersAdminCreateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminCreateMutationFetcher = (options) => {
    return (_, { arg }) => {
        return preordersAdminCreate(arg, options);
    };
};
export const getPreordersAdminCreateMutationKey = () => [`/api/admin/preorders`];
/**
 * @summary 建立預購檔期
 */
export const usePreordersAdminCreate = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersAdminCreateMutationKey();
    const swrFn = getPreordersAdminCreateMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminGetUrl = (id) => {
    return createFullURL(`/api/admin/preorders/${id}`);
};
export const preordersAdminGet = async (id, options) => {
    const res = await fetch(getPreordersAdminGetUrl(id), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminGetKey = (id) => [`/api/admin/preorders/${id}`];
/**
 * @summary 取得預購檔期
 */
export const usePreordersAdminGet = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPreordersAdminGetKey(id) : null));
    const swrFn = () => preordersAdminGet(id, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminUpdateUrl = (id) => {
    return createFullURL(`/api/admin/preorders/${id}`);
};
export const preordersAdminUpdate = async (id, preordersAdminUpdateBody, options) => {
    const res = await fetch(getPreordersAdminUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersAdminUpdateBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminUpdateMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return preordersAdminUpdate(id, arg, options);
    };
};
export const getPreordersAdminUpdateMutationKey = (id) => [`/api/admin/preorders/${id}`];
/**
 * @summary 更新預購檔期
 */
export const usePreordersAdminUpdate = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersAdminUpdateMutationKey(id);
    const swrFn = getPreordersAdminUpdateMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminDeleteUrl = (id) => {
    return createFullURL(`/api/admin/preorders/${id}`);
};
export const preordersAdminDelete = async (id, options) => {
    const res = await fetch(getPreordersAdminDeleteUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminDeleteMutationFetcher = (id, options) => {
    return (_, __) => {
        return preordersAdminDelete(id, options);
    };
};
export const getPreordersAdminDeleteMutationKey = (id) => [`/api/admin/preorders/${id}`];
/**
 * @summary 刪除預購檔期
 */
export const usePreordersAdminDelete = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersAdminDeleteMutationKey(id);
    const swrFn = getPreordersAdminDeleteMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminUpdatePickupQuotasUrl = (id) => {
    return createFullURL(`/api/admin/preorders/${id}/pickup-quotas`);
};
export const preordersAdminUpdatePickupQuotas = async (id, preordersAdminUpdatePickupQuotasBody, options) => {
    const res = await fetch(getPreordersAdminUpdatePickupQuotasUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersAdminUpdatePickupQuotasBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminUpdatePickupQuotasMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return preordersAdminUpdatePickupQuotas(id, arg, options);
    };
};
export const getPreordersAdminUpdatePickupQuotasMutationKey = (id) => [`/api/admin/preorders/${id}/pickup-quotas`];
/**
 * @summary 更新例行檔期依面交日配額
 */
export const usePreordersAdminUpdatePickupQuotas = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersAdminUpdatePickupQuotasMutationKey(id);
    const swrFn = getPreordersAdminUpdatePickupQuotasMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersAdminDeletePickupQuotaUrl = (id) => {
    return createFullURL(`/api/admin/preorders/${id}/pickup-quotas`);
};
export const preordersAdminDeletePickupQuota = async (id, preordersAdminDeletePickupQuotaBody, options) => {
    const res = await fetch(getPreordersAdminDeletePickupQuotaUrl(id), {
        ...options,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersAdminDeletePickupQuotaBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersAdminDeletePickupQuotaMutationFetcher = (id, options) => {
    return (_, { arg }) => {
        return preordersAdminDeletePickupQuota(id, arg, options);
    };
};
export const getPreordersAdminDeletePickupQuotaMutationKey = (id) => [`/api/admin/preorders/${id}/pickup-quotas`];
/**
 * @summary 刪除例行檔期單日商品配額
 */
export const usePreordersAdminDeletePickupQuota = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersAdminDeletePickupQuotaMutationKey(id);
    const swrFn = getPreordersAdminDeletePickupQuotaMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersGetActiveCampaignsUrl = () => {
    return createFullURL(`/api/preorders/active-campaigns`);
};
export const preordersGetActiveCampaigns = async (options) => {
    const res = await fetch(getPreordersGetActiveCampaignsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersGetActiveCampaignsKey = () => [`/api/preorders/active-campaigns`];
/**
 * @summary 取得可預購檔期列表
 */
export const usePreordersGetActiveCampaigns = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPreordersGetActiveCampaignsKey() : null));
    const swrFn = () => preordersGetActiveCampaigns(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersGetActiveUrl = () => {
    return createFullURL(`/api/preorders/active`);
};
export const preordersGetActive = async (options) => {
    const res = await fetch(getPreordersGetActiveUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersGetActiveKey = () => [`/api/preorders/active`];
/**
 * @summary 取得可預購檔期
 */
export const usePreordersGetActive = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPreordersGetActiveKey() : null));
    const swrFn = () => preordersGetActive(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersCreateOrderUrl = () => {
    return createFullURL(`/api/preorders/order`);
};
export const preordersCreateOrder = async (preordersCreateOrderBody, options) => {
    const res = await fetch(getPreordersCreateOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersCreateOrderBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersCreateOrderMutationFetcher = (options) => {
    return (_, { arg }) => {
        return preordersCreateOrder(arg, options);
    };
};
export const getPreordersCreateOrderMutationKey = () => [`/api/preorders/order`];
/**
 * @summary 建立預購訂單
 */
export const usePreordersCreateOrder = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersCreateOrderMutationKey();
    const swrFn = getPreordersCreateOrderMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPreordersCreateOrderForPaymentUrl = () => {
    return createFullURL(`/api/preorders/order-for-payment`);
};
export const preordersCreateOrderForPayment = async (preordersCreateOrderForPaymentBody, options) => {
    const res = await fetch(getPreordersCreateOrderForPaymentUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(preordersCreateOrderForPaymentBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPreordersCreateOrderForPaymentMutationFetcher = (options) => {
    return (_, { arg }) => {
        return preordersCreateOrderForPayment(arg, options);
    };
};
export const getPreordersCreateOrderForPaymentMutationKey = () => [`/api/preorders/order-for-payment`];
/**
 * @summary 建立預購訂單（先填單再付款）
 */
export const usePreordersCreateOrderForPayment = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPreordersCreateOrderForPaymentMutationKey();
    const swrFn = getPreordersCreateOrderForPaymentMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getOnlineOrdersCreateOrderForPaymentUrl = () => {
    return createFullURL(`/api/online-orders/order-for-payment`);
};
export const onlineOrdersCreateOrderForPayment = async (onlineOrdersCreateOrderForPaymentBody, options) => {
    const res = await fetch(getOnlineOrdersCreateOrderForPaymentUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(onlineOrdersCreateOrderForPaymentBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getOnlineOrdersCreateOrderForPaymentMutationFetcher = (options) => {
    return (_, { arg }) => {
        return onlineOrdersCreateOrderForPayment(arg, options);
    };
};
export const getOnlineOrdersCreateOrderForPaymentMutationKey = () => [`/api/online-orders/order-for-payment`];
/**
 * @summary 建立線上訂單（先填單再付款）
 */
export const useOnlineOrdersCreateOrderForPayment = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getOnlineOrdersCreateOrderForPaymentMutationKey();
    const swrFn = getOnlineOrdersCreateOrderForPaymentMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsGetInfoByTransactionIdUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/preorders/payment/info/by-transaction?${stringifiedParams}`)
        : createFullURL(`/api/preorders/payment/info/by-transaction`);
};
export const paymentsGetInfoByTransactionId = async (params, options) => {
    const res = await fetch(getPaymentsGetInfoByTransactionIdUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsGetInfoByTransactionIdKey = (params) => [
    `/api/preorders/payment/info/by-transaction`,
    ...(params ? [params] : []),
];
/**
 * @summary 根據交易 ID 取得支付資訊
 */
export const usePaymentsGetInfoByTransactionId = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPaymentsGetInfoByTransactionIdKey(params) : null));
    const swrFn = () => paymentsGetInfoByTransactionId(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsGetInfoByOrderIdUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/preorders/payment/info/by-order?${stringifiedParams}`)
        : createFullURL(`/api/preorders/payment/info/by-order`);
};
export const paymentsGetInfoByOrderId = async (params, options) => {
    const res = await fetch(getPaymentsGetInfoByOrderIdUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsGetInfoByOrderIdKey = (params) => [
    `/api/preorders/payment/info/by-order`,
    ...(params ? [params] : []),
];
/**
 * @summary 根據訂單 ID 取得支付資訊
 */
export const usePaymentsGetInfoByOrderId = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPaymentsGetInfoByOrderIdKey(params) : null));
    const swrFn = () => paymentsGetInfoByOrderId(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsGetInfoByOrderNumberUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/preorders/payment/info/by-order-number?${stringifiedParams}`)
        : createFullURL(`/api/preorders/payment/info/by-order-number`);
};
export const paymentsGetInfoByOrderNumber = async (params, options) => {
    const res = await fetch(getPaymentsGetInfoByOrderNumberUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsGetInfoByOrderNumberKey = (params) => [
    `/api/preorders/payment/info/by-order-number`,
    ...(params ? [params] : []),
];
/**
 * @summary 根據訂單編號取得支付資訊
 */
export const usePaymentsGetInfoByOrderNumber = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPaymentsGetInfoByOrderNumberKey(params) : null));
    const swrFn = () => paymentsGetInfoByOrderNumber(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsGetInfoUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/preorders/payment/info?${stringifiedParams}`)
        : createFullURL(`/api/preorders/payment/info`);
};
export const paymentsGetInfo = async (params, options) => {
    const res = await fetch(getPaymentsGetInfoUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsGetInfoKey = (params) => [`/api/preorders/payment/info`, ...(params ? [params] : [])];
/**
 * @summary 取得支付資訊
 */
export const usePaymentsGetInfo = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getPaymentsGetInfoKey(params) : null));
    const swrFn = () => paymentsGetInfo(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsRequestPaymentUrl = () => {
    return createFullURL(`/api/preorders/payment/request`);
};
export const paymentsRequestPayment = async (paymentsRequestPaymentBody, options) => {
    const res = await fetch(getPaymentsRequestPaymentUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(paymentsRequestPaymentBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsRequestPaymentMutationFetcher = (options) => {
    return (_, { arg }) => {
        return paymentsRequestPayment(arg, options);
    };
};
export const getPaymentsRequestPaymentMutationKey = () => [`/api/preorders/payment/request`];
/**
 * @summary 請求支付（依 orderId）
 */
export const usePaymentsRequestPayment = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPaymentsRequestPaymentMutationKey();
    const swrFn = getPaymentsRequestPaymentMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPaymentsConfirmLinePayUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/preorders/payment/confirm?${stringifiedParams}`)
        : createFullURL(`/api/preorders/payment/confirm`);
};
export const paymentsConfirmLinePay = async (paymentsConfirmLinePayBody, params, options) => {
    const res = await fetch(getPaymentsConfirmLinePayUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(paymentsConfirmLinePayBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPaymentsConfirmLinePayMutationFetcher = (params, options) => {
    return (_, { arg }) => {
        return paymentsConfirmLinePay(arg, params, options);
    };
};
export const getPaymentsConfirmLinePayMutationKey = (params) => [`/api/preorders/payment/confirm`, ...(params ? [params] : [])];
/**
 * @summary 確認 LINE Pay 支付
 */
export const usePaymentsConfirmLinePay = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPaymentsConfirmLinePayMutationKey(params);
    const swrFn = getPaymentsConfirmLinePayMutationFetcher(params, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiAuthGoogleUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/auth/google?${stringifiedParams}`)
        : createFullURL(`/api/auth/google`);
};
export const getApiAuthGoogle = async (params, options) => {
    const res = await fetch(getGetApiAuthGoogleUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiAuthGoogleKey = (params) => [`/api/auth/google`, ...(params ? [params] : [])];
/**
 * @summary Google OAuth 登入
 */
export const useGetApiAuthGoogle = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiAuthGoogleKey(params) : null));
    const swrFn = () => getApiAuthGoogle(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiAuthGoogleCallbackUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/auth/google/callback?${stringifiedParams}`)
        : createFullURL(`/api/auth/google/callback`);
};
export const getApiAuthGoogleCallback = async (params, options) => {
    const res = await fetch(getGetApiAuthGoogleCallbackUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiAuthGoogleCallbackKey = (params) => [`/api/auth/google/callback`, ...(params ? [params] : [])];
/**
 * @summary Google OAuth 回調
 */
export const useGetApiAuthGoogleCallback = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiAuthGoogleCallbackKey(params) : null));
    const swrFn = () => getApiAuthGoogleCallback(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiAuthVerifyUrl = () => {
    return createFullURL(`/api/auth/verify`);
};
export const postApiAuthVerify = async (postApiAuthVerifyBody, options) => {
    const res = await fetch(getPostApiAuthVerifyUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiAuthVerifyBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiAuthVerifyMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiAuthVerify(arg, options);
    };
};
export const getPostApiAuthVerifyMutationKey = () => [`/api/auth/verify`];
/**
 * @summary 驗證 JWT Token
 */
export const usePostApiAuthVerify = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiAuthVerifyMutationKey();
    const swrFn = getPostApiAuthVerifyMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiAuthTenantsUrl = () => {
    return createFullURL(`/api/auth/tenants`);
};
export const postApiAuthTenants = async (postApiAuthTenantsBody, options) => {
    const res = await fetch(getPostApiAuthTenantsUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(postApiAuthTenantsBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiAuthTenantsMutationFetcher = (options) => {
    return (_, { arg }) => {
        return postApiAuthTenants(arg, options);
    };
};
export const getPostApiAuthTenantsMutationKey = () => [`/api/auth/tenants`];
/**
 * @summary 建立新 Tenant
 */
export const usePostApiAuthTenants = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getPostApiAuthTenantsMutationKey();
    const swrFn = getPostApiAuthTenantsMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getPostApiAuthInvitesInviteCodeUrl = (inviteCode) => {
    return createFullURL(`/api/auth/invites/${inviteCode}`);
};
export const postApiAuthInvitesInviteCode = async (inviteCode, options) => {
    const res = await fetch(getPostApiAuthInvitesInviteCodeUrl(inviteCode), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getPostApiAuthInvitesInviteCodeMutationFetcher = (inviteCode, options) => {
    return (_, __) => {
        return postApiAuthInvitesInviteCode(inviteCode, options);
    };
};
export const getPostApiAuthInvitesInviteCodeMutationKey = (inviteCode) => [`/api/auth/invites/${inviteCode}`];
/**
 * @summary 接受邀請
 */
export const usePostApiAuthInvitesInviteCode = (inviteCode, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ??
        getPostApiAuthInvitesInviteCodeMutationKey(inviteCode);
    const swrFn = getPostApiAuthInvitesInviteCodeMutationFetcher(inviteCode, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getGetApiAuthUserTenantsUrl = () => {
    return createFullURL(`/api/auth/user/tenants`);
};
export const getApiAuthUserTenants = async (options) => {
    const res = await fetch(getGetApiAuthUserTenantsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getGetApiAuthUserTenantsKey = () => [`/api/auth/user/tenants`];
/**
 * @summary 取得使用者所屬的 Tenants
 */
export const useGetApiAuthUserTenants = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getGetApiAuthUserTenantsKey() : null));
    const swrFn = () => getApiAuthUserTenants(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getAuthDeviceVerifyPinUrl = () => {
    return createFullURL(`/api/auth/device/verify-pin`);
};
export const authDeviceVerifyPin = async (authDeviceVerifyPinBody, options) => {
    const res = await fetch(getAuthDeviceVerifyPinUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(authDeviceVerifyPinBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getAuthDeviceVerifyPinMutationFetcher = (options) => {
    return (_, { arg }) => {
        return authDeviceVerifyPin(arg, options);
    };
};
export const getAuthDeviceVerifyPinMutationKey = () => [`/api/auth/device/verify-pin`];
/**
 * @summary 驗證 PIN 碼
 */
export const useAuthDeviceVerifyPin = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getAuthDeviceVerifyPinMutationKey();
    const swrFn = getAuthDeviceVerifyPinMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsGetMeUrl = () => {
    return createFullURL(`/api/tenants/me`);
};
export const tenantsGetMe = async (options) => {
    const res = await fetch(getTenantsGetMeUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsGetMeKey = () => [`/api/tenants/me`];
/**
 * @summary 取得當前商家資訊
 */
export const useTenantsGetMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTenantsGetMeKey() : null));
    const swrFn = () => tenantsGetMe(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsUpdateMeUrl = () => {
    return createFullURL(`/api/tenants/me`);
};
export const tenantsUpdateMe = async (tenantsUpdateMeBody, options) => {
    const res = await fetch(getTenantsUpdateMeUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tenantsUpdateMeBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsUpdateMeMutationFetcher = (options) => {
    return (_, { arg }) => {
        return tenantsUpdateMe(arg, options);
    };
};
export const getTenantsUpdateMeMutationKey = () => [`/api/tenants/me`];
/**
 * @summary 更新當前商家資訊
 */
export const useTenantsUpdateMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantsUpdateMeMutationKey();
    const swrFn = getTenantsUpdateMeMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsDeleteMeUrl = () => {
    return createFullURL(`/api/tenants/me`);
};
export const tenantsDeleteMe = async (tenantsDeleteMeBody, options) => {
    const res = await fetch(getTenantsDeleteMeUrl(), {
        ...options,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tenantsDeleteMeBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsDeleteMeMutationFetcher = (options) => {
    return (_, { arg }) => {
        return tenantsDeleteMe(arg, options);
    };
};
export const getTenantsDeleteMeMutationKey = () => [`/api/tenants/me`];
/**
 * @summary 刪除當前商家
 */
export const useTenantsDeleteMe = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantsDeleteMeMutationKey();
    const swrFn = getTenantsDeleteMeMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsVerifyLineChannelUrl = () => {
    return createFullURL(`/api/tenants/me/verify-line`);
};
export const tenantsVerifyLineChannel = async (options) => {
    const res = await fetch(getTenantsVerifyLineChannelUrl(), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsVerifyLineChannelMutationFetcher = (options) => {
    return (_, __) => {
        return tenantsVerifyLineChannel(options);
    };
};
export const getTenantsVerifyLineChannelMutationKey = () => [`/api/tenants/me/verify-line`];
/**
 * @summary 驗證 LINE Channel 連線
 */
export const useTenantsVerifyLineChannel = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantsVerifyLineChannelMutationKey();
    const swrFn = getTenantsVerifyLineChannelMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsGetFeatureFlagsUrl = (tenantId) => {
    return createFullURL(`/api/tenants/${tenantId}/feature-flags`);
};
export const tenantsGetFeatureFlags = async (tenantId, options) => {
    const res = await fetch(getTenantsGetFeatureFlagsUrl(tenantId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsGetFeatureFlagsKey = (tenantId) => [`/api/tenants/${tenantId}/feature-flags`];
/**
 * @summary 取得租戶啟用的 Feature Flags
 */
export const useTenantsGetFeatureFlags = (tenantId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!tenantId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getTenantsGetFeatureFlagsKey(tenantId) : null));
    const swrFn = () => tenantsGetFeatureFlags(tenantId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantsGetCheckoutConfigUrl = (tenantId) => {
    return createFullURL(`/api/tenants/${tenantId}/checkout-config`);
};
export const tenantsGetCheckoutConfig = async (tenantId, options) => {
    const res = await fetch(getTenantsGetCheckoutConfigUrl(tenantId), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantsGetCheckoutConfigKey = (tenantId) => [`/api/tenants/${tenantId}/checkout-config`];
/**
 * @summary 取得租戶結帳頁公開設定
 */
export const useTenantsGetCheckoutConfig = (tenantId, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false && !!tenantId;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getTenantsGetCheckoutConfigKey(tenantId) : null));
    const swrFn = () => tenantsGetCheckoutConfig(tenantId, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getContextResolveUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/context/resolve?${stringifiedParams}`)
        : createFullURL(`/api/context/resolve`);
};
export const contextResolve = async (params, options) => {
    const res = await fetch(getContextResolveUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getContextResolveKey = (params) => [`/api/context/resolve`, ...(params ? [params] : [])];
/**
 * @summary 解析群組綁定狀態
 */
export const useContextResolve = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getContextResolveKey(params) : null));
    const swrFn = () => contextResolve(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getContextBindUrl = () => {
    return createFullURL(`/api/context/bind`);
};
export const contextBind = async (contextBindBody, options) => {
    const res = await fetch(getContextBindUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(contextBindBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getContextBindMutationFetcher = (options) => {
    return (_, { arg }) => {
        return contextBind(arg, options);
    };
};
export const getContextBindMutationKey = () => [`/api/context/bind`];
/**
 * @summary 綁定群組與 Tenant
 */
export const useContextBind = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getContextBindMutationKey();
    const swrFn = getContextBindMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getUsersGetMyTenantsUrl = () => {
    return createFullURL(`/api/users/me/tenants`);
};
export const usersGetMyTenants = async (options) => {
    const res = await fetch(getUsersGetMyTenantsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getUsersGetMyTenantsKey = () => [`/api/users/me/tenants`];
/**
 * @summary 取得當前使用者擁有的 Tenants
 */
export const useUsersGetMyTenants = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getUsersGetMyTenantsKey() : null));
    const swrFn = () => usersGetMyTenants(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantSubscriptionStatusUrl = () => {
    return createFullURL(`/api/tenants/subscription/status`);
};
export const tenantSubscriptionStatus = async (options) => {
    const res = await fetch(getTenantSubscriptionStatusUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantSubscriptionStatusKey = () => [`/api/tenants/subscription/status`];
/**
 * @summary 訂閱狀態
 */
export const useTenantSubscriptionStatus = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getTenantSubscriptionStatusKey() : null));
    const swrFn = () => tenantSubscriptionStatus(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantSubscriptionPayUrl = () => {
    return createFullURL(`/api/tenants/subscription/pay`);
};
export const tenantSubscriptionPay = async (tenantSubscriptionPayBody, options) => {
    const res = await fetch(getTenantSubscriptionPayUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tenantSubscriptionPayBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantSubscriptionPayMutationFetcher = (options) => {
    return (_, { arg }) => {
        return tenantSubscriptionPay(arg, options);
    };
};
export const getTenantSubscriptionPayMutationKey = () => [`/api/tenants/subscription/pay`];
/**
 * @summary 訂閱付款（Pay by Prime）
 */
export const useTenantSubscriptionPay = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantSubscriptionPayMutationKey();
    const swrFn = getTenantSubscriptionPayMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantSubscriptionCancelUrl = () => {
    return createFullURL(`/api/tenants/subscription/cancel`);
};
export const tenantSubscriptionCancel = async (options) => {
    const res = await fetch(getTenantSubscriptionCancelUrl(), {
        ...options,
        method: 'POST',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantSubscriptionCancelMutationFetcher = (options) => {
    return (_, __) => {
        return tenantSubscriptionCancel(options);
    };
};
export const getTenantSubscriptionCancelMutationKey = () => [`/api/tenants/subscription/cancel`];
/**
 * @summary 取消訂閱（本期結束後不續訂）
 */
export const useTenantSubscriptionCancel = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantSubscriptionCancelMutationKey();
    const swrFn = getTenantSubscriptionCancelMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getTenantSubscriptionPayEcPayUrl = () => {
    return createFullURL(`/api/tenants/subscription/pay-ecpay`);
};
export const tenantSubscriptionPayEcPay = async (tenantSubscriptionPayEcPayBody, options) => {
    const res = await fetch(getTenantSubscriptionPayEcPayUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tenantSubscriptionPayEcPayBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body
        ? JSON.parse(body)
        : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getTenantSubscriptionPayEcPayMutationFetcher = (options) => {
    return (_, { arg }) => {
        return tenantSubscriptionPayEcPay(arg, options);
    };
};
export const getTenantSubscriptionPayEcPayMutationKey = () => [`/api/tenants/subscription/pay-ecpay`];
/**
 * @summary 訂閱付款（綠界金流）
 */
export const useTenantSubscriptionPayEcPay = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getTenantSubscriptionPayEcPayMutationKey();
    const swrFn = getTenantSubscriptionPayEcPayMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGUploadKnowledgeUrl = () => {
    return createFullURL(`/api/rag/knowledge/upload`);
};
export const rAGUploadKnowledge = async (rAGUploadKnowledgeBody, options) => {
    const formData = new FormData();
    formData.append(`title`, rAGUploadKnowledgeBody.title);
    if (rAGUploadKnowledgeBody.file !== undefined &&
        rAGUploadKnowledgeBody.file !== null &&
        typeof rAGUploadKnowledgeBody.file === 'object' &&
        rAGUploadKnowledgeBody.file instanceof Blob) {
        formData.append(`file`, rAGUploadKnowledgeBody.file);
    }
    const res = await fetch(getRAGUploadKnowledgeUrl(), {
        ...options,
        method: 'POST',
        body: formData,
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGUploadKnowledgeMutationFetcher = (options) => {
    return (_, { arg }) => {
        return rAGUploadKnowledge(arg, options);
    };
};
export const getRAGUploadKnowledgeMutationKey = () => [`/api/rag/knowledge/upload`];
/**
 * @summary 上傳檔案並建立知識
 */
export const useRAGUploadKnowledge = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getRAGUploadKnowledgeMutationKey();
    const swrFn = getRAGUploadKnowledgeMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGCreateKnowledgeUrl = () => {
    return createFullURL(`/api/rag/knowledge`);
};
export const rAGCreateKnowledge = async (rAGCreateKnowledgeBody, options) => {
    const res = await fetch(getRAGCreateKnowledgeUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rAGCreateKnowledgeBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGCreateKnowledgeMutationFetcher = (options) => {
    return (_, { arg }) => {
        return rAGCreateKnowledge(arg, options);
    };
};
export const getRAGCreateKnowledgeMutationKey = () => [`/api/rag/knowledge`];
/**
 * @summary 手動建立知識
 */
export const useRAGCreateKnowledge = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getRAGCreateKnowledgeMutationKey();
    const swrFn = getRAGCreateKnowledgeMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGListKnowledgeUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/rag/knowledge?${stringifiedParams}`)
        : createFullURL(`/api/rag/knowledge`);
};
export const rAGListKnowledge = async (params, options) => {
    const res = await fetch(getRAGListKnowledgeUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGListKnowledgeKey = (params) => [`/api/rag/knowledge`, ...(params ? [params] : [])];
/**
 * @summary 取得知識列表
 */
export const useRAGListKnowledge = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getRAGListKnowledgeKey(params) : null));
    const swrFn = () => rAGListKnowledge(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGDeleteKnowledgeUrl = (id) => {
    return createFullURL(`/api/rag/knowledge/${id}`);
};
export const rAGDeleteKnowledge = async (id, options) => {
    const res = await fetch(getRAGDeleteKnowledgeUrl(id), {
        ...options,
        method: 'DELETE',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGDeleteKnowledgeMutationFetcher = (id, options) => {
    return (_, __) => {
        return rAGDeleteKnowledge(id, options);
    };
};
export const getRAGDeleteKnowledgeMutationKey = (id) => [`/api/rag/knowledge/${id}`];
/**
 * @summary 刪除知識
 */
export const useRAGDeleteKnowledge = (id, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getRAGDeleteKnowledgeMutationKey(id);
    const swrFn = getRAGDeleteKnowledgeMutationFetcher(id, fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGAskUrl = () => {
    return createFullURL(`/api/rag/ask`);
};
export const rAGAsk = async (rAGAskBody, options) => {
    const res = await fetch(getRAGAskUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(rAGAskBody),
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return { data, status: res.status, headers: res.headers };
};
export const getRAGAskMutationFetcher = (options) => {
    return (_, { arg }) => {
        return rAGAsk(arg, options);
    };
};
export const getRAGAskMutationKey = () => [`/api/rag/ask`];
/**
 * @summary 提問
 */
export const useRAGAsk = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const swrKey = swrOptions?.swrKey ?? getRAGAskMutationKey();
    const swrFn = getRAGAskMutationFetcher(fetchOptions);
    const query = useSWRMutation(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGGetStatsUrl = () => {
    return createFullURL(`/api/rag/stats`);
};
export const rAGGetStats = async (options) => {
    const res = await fetch(getRAGGetStatsUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGGetStatsKey = () => [`/api/rag/stats`];
/**
 * @summary 取得統計資訊
 */
export const useRAGGetStats = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getRAGGetStatsKey() : null));
    const swrFn = () => rAGGetStats(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGListChatStatsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0
        ? createFullURL(`/api/rag/stats/chats?${stringifiedParams}`)
        : createFullURL(`/api/rag/stats/chats`);
};
export const rAGListChatStats = async (params, options) => {
    const res = await fetch(getRAGListChatStatsUrl(params), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGListChatStatsKey = (params) => [`/api/rag/stats/chats`, ...(params ? [params] : [])];
/**
 * @summary 取得對話記錄
 */
export const useRAGListChatStats = (params, options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getRAGListChatStatsKey(params) : null));
    const swrFn = () => rAGListChatStats(params, fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
export const getRAGDebugVectorizeUrl = () => {
    return createFullURL(`/api/rag/debug/vectorize`);
};
export const rAGDebugVectorize = async (options) => {
    const res = await fetch(getRAGDebugVectorizeUrl(), {
        ...options,
        method: 'GET',
    });
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();
    const data = body ? JSON.parse(body) : {};
    return {
        data,
        status: res.status,
        headers: res.headers,
    };
};
export const getRAGDebugVectorizeKey = () => [`/api/rag/debug/vectorize`];
/**
 * @summary 診斷 Vectorize 資料
 */
export const useRAGDebugVectorize = (options) => {
    const { swr: swrOptions, fetch: fetchOptions } = options ?? {};
    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ??
        (() => (isEnabled ? getRAGDebugVectorizeKey() : null));
    const swrFn = () => rAGDebugVectorize(fetchOptions);
    const query = useSwr(swrKey, swrFn, swrOptions);
    return {
        swrKey,
        ...query,
    };
};
